import * as Astronomy from "astronomy-engine";

// =================================================================
// 1. 定数定義
// =================================================================
export const PLANET_BODIES = {
  Sun: Astronomy.Body.Sun,
  Moon: Astronomy.Body.Moon,
  Mercury: Astronomy.Body.Mercury,
  Venus: Astronomy.Body.Venus,
  Earth: Astronomy.Body.Earth,
  Mars: Astronomy.Body.Mars,
  Jupiter: Astronomy.Body.Jupiter,
  Saturn: Astronomy.Body.Saturn,
  Uranus: Astronomy.Body.Uranus,
  Neptune: Astronomy.Body.Neptune,
  Pluto: Astronomy.Body.Pluto,
};

// 外部の拡張用JSファイルなどが要求しているライブラリ機能を、このファイル経由で公開します
export const MakeTime = Astronomy.MakeTime;
export const Body = Astronomy.Body;
export const HelioVector = Astronomy.HelioVector;

export const GeoVector = Astronomy.GeoVector;
export const EclipticGeoMoon = Astronomy.EclipticGeoMoon;

const RETROGRADE_PLANETS = [
  "Mercury",
  "Venus",
  "Mars",
  "Jupiter",
  "Saturn",
  "Uranus",
  "Neptune",
  "Pluto",
];
const MAJOR_PLANETS = [
  "Sun",
  "Moon",
  "Mercury",
  "Venus",
  "Mars",
  "Jupiter",
  "Saturn",
  "Uranus",
  "Neptune",
  "Pluto",
];

// 惑星の公転周期（日）
const ORBITAL_PERIODS = {
  Sun: 365.25,
  Moon: 27.32,
  Mercury: 87.97,
  Venus: 224.7,
  Mars: 687,
  Jupiter: 4332,
  Saturn: 10759,
  Uranus: 30685,
  Neptune: 60190,
  Pluto: 90560,
};

export const ASPECTS = {
  major: [
    { name: "Conjunction", symbol: "☌", angle: 0, orb: 8 },
    { name: "Opposition", symbol: "☍", angle: 180, orb: 8 },
    { name: "Trine", symbol: "△", angle: 120, orb: 8 },
    { name: "Square", symbol: "□", angle: 90, orb: 7 },
    { name: "Sextile", symbol: "⚹", angle: 60, orb: 6 },
  ],
  minor: [
    { name: "Semi-sextile", symbol: "⚺", angle: 30, orb: 2 },
    { name: "Quincunx", symbol: "⚻", angle: 150, orb: 3 },
    { name: "Semi-square", symbol: "∠", angle: 45, orb: 2 },
    { name: "Sesquiquadrate", symbol: "⚼", angle: 135, orb: 2 },
    { name: "Quintile", symbol: "Q", angle: 72, orb: 2 },
    { name: "Bi-quintile", symbol: "bQ", angle: 144, orb: 2 },
  ],
  hard: [
    { name: "Conjunction", symbol: "☌", angle: 0, orb: 8 },
    { name: "Opposition", symbol: "☍", angle: 180, orb: 8 },
    { name: "Square", symbol: "□", angle: 90, orb: 7 },
    { name: "Semi-square", symbol: "∠", angle: 45, orb: 2 },
    { name: "Sesquiquadrate", symbol: "⚼", angle: 135, orb: 2 },
  ],
};

const ZODIAC_SIGNS = [
  { name: "Aries", symbol: "♈", element: "Fire", modality: "Cardinal" },
  { name: "Taurus", symbol: "♉", element: "Earth", modality: "Fixed" },
  { name: "Gemini", symbol: "♊", element: "Air", modality: "Mutable" },
  { name: "Cancer", symbol: "♋", element: "Water", modality: "Cardinal" },
  { name: "Leo", symbol: "♌", element: "Fire", modality: "Fixed" },
  { name: "Virgo", symbol: "♍", element: "Earth", modality: "Mutable" },
  { name: "Libra", symbol: "♎", element: "Air", modality: "Cardinal" },
  { name: "Scorpio", symbol: "♏", element: "Water", modality: "Fixed" },
  { name: "Sagittarius", symbol: "♐", element: "Fire", modality: "Mutable" },
  { name: "Capricorn", symbol: "♑", element: "Earth", modality: "Cardinal" },
  { name: "Aquarius", symbol: "♒", element: "Air", modality: "Fixed" },
  { name: "Pisces", symbol: "♓", element: "Water", modality: "Mutable" },
];

const SOLAR_TERMS = [
  { name: "春分", reading: "しゅんぶん", longitude: 0, season: "春" },
  { name: "清明", reading: "せいめい", longitude: 15, season: "春" },
  { name: "穀雨", reading: "こくう", longitude: 30, season: "春" },
  { name: "立夏", reading: "りっか", longitude: 45, season: "夏" },
  { name: "小満", reading: "しょうまん", longitude: 60, season: "夏" },
  { name: "芒種", reading: "ぼうしゅ", longitude: 75, season: "夏" },
  { name: "夏至", reading: "げし", longitude: 90, season: "夏" },
  { name: "小暑", reading: "しょうしょ", longitude: 105, season: "夏" },
  { name: "大暑", reading: "たいしょ", longitude: 120, season: "夏" },
  { name: "立秋", reading: "りっしゅう", longitude: 135, season: "秋" },
  { name: "処暑", reading: "しょしょ", longitude: 150, season: "秋" },
  { name: "白露", reading: "はくろ", longitude: 165, season: "秋" },
  { name: "秋分", reading: "しゅうぶん", longitude: 180, season: "秋" },
  { name: "寒露", reading: "かんろ", longitude: 195, season: "秋" },
  { name: "霜降", reading: "そうこう", longitude: 210, season: "秋" },
  { name: "立冬", reading: "りっとう", longitude: 225, season: "冬" },
  { name: "小雪", reading: "しょうせつ", longitude: 240, season: "冬" },
  { name: "大雪", reading: "たいせつ", longitude: 255, season: "冬" },
  { name: "冬至", reading: "とうじ", longitude: 270, season: "冬" },
  { name: "小寒", reading: "しょうかん", longitude: 285, season: "冬" },
  { name: "大寒", reading: "だいかん", longitude: 300, season: "冬" },
  { name: "立春", reading: "りっしゅん", longitude: 315, season: "春" },
  { name: "雨水", reading: "うすい", longitude: 330, season: "春" },
  { name: "啓蟄", reading: "けいちつ", longitude: 345, season: "春" },
];

export const POINT_SYMBOLS = {
  NorthNode: "☊",
  SouthNode: "☋",
  ASC: "AC",
  MC: "MC",
  DSC: "DC",
  IC: "IC",
};

// 惑星の品位（ディグニティー）定義
const PLANET_DIGNITIES = {
  Sun: { dom: ["Leo"], ex: ["Aries"], det: ["Aquarius"], fall: ["Libra"] },
  Moon: {
    dom: ["Cancer"],
    ex: ["Taurus"],
    det: ["Capricorn"],
    fall: ["Scorpio"],
  },
  Mercury: {
    dom: ["Gemini", "Virgo"],
    ex: ["Virgo"],
    det: ["Sagittarius", "Pisces"],
    fall: ["Pisces"],
  },
  Venus: {
    dom: ["Taurus", "Libra"],
    ex: ["Pisces"],
    det: ["Scorpio", "Aries"],
    fall: ["Virgo"],
  },
  Mars: {
    dom: ["Aries", "Scorpio"],
    ex: ["Capricorn"],
    det: ["Libra", "Taurus"],
    fall: ["Cancer"],
  },
  Jupiter: {
    dom: ["Sagittarius", "Pisces"],
    ex: ["Cancer"],
    det: ["Gemini", "Virgo"],
    fall: ["Capricorn"],
  },
  Saturn: {
    dom: ["Capricorn", "Aquarius"],
    ex: ["Libra"],
    det: ["Cancer", "Leo"],
    fall: ["Aries"],
  },
  Uranus: {
    dom: ["Aquarius"],
    ex: ["Scorpio"],
    det: ["Leo"],
    fall: ["Taurus"],
  },
  Neptune: { dom: ["Pisces"], ex: [], det: ["Virgo"], fall: [] },
  Pluto: { dom: ["Scorpio"], ex: [], det: ["Taurus"], fall: [] },
};

export { ZODIAC_SIGNS, RETROGRADE_PLANETS, SOLAR_TERMS };

// =================================================================
// 2. 基本ヘルパー関数
// =================================================================

export function createDate(dateStr, timeStr = "12:00", tzOffset = 0) {
  const [year, month, day] = dateStr.split("-").map(Number);
  const [hour, minute] = timeStr.split(":").map(Number);
  const utcHour = hour - tzOffset;
  return new Date(Date.UTC(year, month - 1, day, utcHour, minute, 0));
}

export function dateToJulianDay(date) {
  const year = date.getUTCFullYear();
  const month = date.getUTCMonth() + 1;
  const day = date.getUTCDate();
  const hour =
    date.getUTCHours() +
    date.getUTCMinutes() / 60 +
    date.getUTCSeconds() / 3600;
  let y = year,
    m = month;
  if (m <= 2) {
    y -= 1;
    m += 12;
  }
  const a = Math.floor(y / 100);
  const b = 2 - a + Math.floor(a / 4);
  return (
    Math.floor(365.25 * (y + 4716)) +
    Math.floor(30.6001 * (m + 1)) +
    day +
    hour / 24 +
    b -
    1524.5
  );
}

export function normalizeDegrees(deg) {
  deg = deg % 360;
  if (deg < 0) deg += 360;
  return deg;
}

// 角度差を -180 ~ 180 に正規化するヘルパー関数 (ここ1箇所のみで定義)
function normalizeDiff(d) {
  while (d <= -180) d += 360;
  while (d > 180) d -= 360;
  return d;
}

/**
 * サイン（星座）判定。サイデリアルが有効な場合はアヤナンシャを考慮する。
 */
// 基本定数の定義
export const MS_PER_DAY = 86400000;
export const JD_UNIX_EPOCH = 2440587.5;
export const JD_J2000 = 2451545.0;

/**
 * ラヒリ・アヤナンシャ（歳差補正値）の計算を統一
 */
export function calculateLahiriAyanamsha(date) {
  const jd = date.getTime() / MS_PER_DAY + JD_UNIX_EPOCH;
  // より精密なラヒリ・アヤナンシャの計算式 (2026年等の未来データに対応)
  return 23.85 + ((50.2564 / 3600) * (jd - JD_J2000)) / 365.25;
}

export const getAyanamsha = calculateLahiriAyanamsha;

export function getZodiacSign(
  longitude,
  isSidereal = false,
  date = new Date(),
) {
  var displayLon = (longitude + 360) % 360;

  if (isSidereal === true && date) {
    const ayan = calculateLahiriAyanamsha(date);
    displayLon = (displayLon - ayan + 360) % 360;
  }

  var index = Math.floor(displayLon / 30) % 12;
  return ZODIAC_SIGNS[index];
}

export function formatDMS(degrees) {
  // 360度内に正規化
  const norm = ((degrees % 360) + 360) % 360;
  // 浮動小数点誤差を避けるため秒単位で丸める（丸めにより60秒になるのを防ぐ）
  const totalSeconds = Math.round(norm * 3600);

  const d = Math.floor(totalSeconds / 3600);
  const m = Math.floor((totalSeconds % 3600) / 60);
  const s = totalSeconds % 60;

  // 表示の際は 60秒/60分にならないよう formatDMSPrecise と共通の定義を使用
  return `${d}°${m.toString().padStart(2, "0")}'${s.toString().padStart(2, "0")}"`;
}

// Dial90Chart などで使用する精密表記用エイリアス
export const formatDMSPrecise = formatDMS;

export function formatSignDegree(longitude) {
  const sign = getZodiacSign(longitude);
  const degInSign = longitude % 30;
  const deg = Math.floor(degInSign);
  const min = Math.floor((degInSign - deg) * 60);
  return `${deg}  ${min.toString().padStart(2, "0")}' ${sign.symbol}`;
}

export function getDignity(planet, signName) {
  const d = PLANET_DIGNITIES[planet];
  if (!d) return null;
  if (d.dom.includes(signName))
    return {
      type: "domicile",
      label: "Domicile (本来の座)",
      icon: "🏠",
      score: 5,
    };
  if (d.ex.includes(signName))
    return {
      type: "exaltation",
      label: "Exaltation (高揚)",
      icon: "👑",
      score: 4,
    };
  if (d.det.includes(signName))
    return {
      type: "detriment",
      label: "Detriment (障害)",
      icon: "🏚️",
      score: -5,
    };
  if (d.fall.includes(signName))
    return { type: "fall", label: "Fall (転落)", icon: "🍂", score: -4 };
  return null;
}

/**
 * 惑星位置取得（ジオセントリック）
 * 修正内容：
 * 1. Astronomy.Ecliptic(vector) の引数を修正し、計算エラーを解消しました。
 * 2. elon プロパティへのアクセスを確実に行います。
 */
export function getPlanetLongitude(planet, date) {
  try {
    const body = PLANET_BODIES[planet];
    if (!body) return null;

    // 日付の正規化 (Dateオブジェクト、数値に対応)
    var d = date instanceof Date ? date : new Date(date);
    if (isNaN(d.getTime())) return null;

    const time = Astronomy.MakeTime(d);

    if (planet === "Moon") {
      const moonEcl = Astronomy.EclipticGeoMoon(time);
      return normalizeDegrees(moonEcl.lon);
    } else {
      // ジオセントリックベクトル（光行差・収差補正あり）
      const vector = Astronomy.GeoVector(body, time, true);
      // 黄道座標への変換（引数はベクトル1つのみが正解）
      const ecliptic = Astronomy.Ecliptic(vector);

      // Sphericalオブジェクトから黄経(elon)を取得
      var lonValue = ecliptic.elon !== undefined ? ecliptic.elon : ecliptic.lon;

      if (lonValue === undefined || lonValue === null) return null;
      return normalizeDegrees(lonValue);
    }
  } catch (e) {
    console.error("getPlanetLongitude error:", planet, e);
    return null;
  }
}

export function getAllPlanetLongitudes(date) {
  const positions = {};
  Object.keys(PLANET_BODIES).forEach((planet) => {
    // ジオセントリック（地球中心）計算時は、地球自身を除外する
    if (planet === "Earth") return;
    positions[planet] = getPlanetLongitude(planet, date);
  });
  return positions;
}

/**
 * ヘリオセントリック黄経取得 (10惑星・当日真黄道基準・高精度時刻補正版)
 * 2026/1/28 12:00 JST 時点での国立天文台の数値(水瓶座 25°08')と一致させるための修正
 */
export function getHeliocentricLongitude(planet, date) {
  try {
    if (planet === "Sun" || planet === "Moon" || !date) return null;

    // 修正：不要なタイムゾーン補正を削除。
    // dateは既にUTCとして生成されているため、そのまま渡す。
    const time = Astronomy.MakeTime(date);

    const body =
      planet === "Earth" ? Astronomy.Body.Earth : PLANET_BODIES[planet];
    if (!body) return null;

    const vec = Astronomy.HelioVector(body, time);
    const ecl = Astronomy.Ecliptic(vec, time);

    return normalizeDegrees(ecl.elon);
  } catch (e) {
    console.error("getHeliocentricLongitude error:", planet, e);
    return null;
  }
}

/**
 * 全主要惑星のヘリオセントリック黄経を一括取得 (高精度時刻補正版)
 */
export function getAllHeliocentricLongitudes(date) {
  const positions = {};
  const planets = [
    "Mercury",
    "Venus",
    "Earth",
    "Mars",
    "Jupiter",
    "Saturn",
    "Uranus",
    "Neptune",
    "Pluto",
  ];

  if (!date) return positions;
  // 修正：Astro.MakeTime に統一し、手動のオフセット調整を排除
  const time = Astronomy.MakeTime(date);

  planets.forEach(function (planet) {
    try {
      const body =
        planet === "Earth" ? Astronomy.Body.Earth : PLANET_BODIES[planet];
      if (!body) {
        positions[planet] = null;
        return;
      }
      const vec = Astronomy.HelioVector(body, time);
      const ecl = Astronomy.Ecliptic(vec, time); // 当日真黄道
      positions[planet] = normalizeDegrees(ecl.elon);
    } catch (e) {
      positions[planet] = null;
    }
  });
  return positions;
}

/**
 * ソーラーアーク黄経の計算（ノエル・ティル式: 1日1年法）
 * 出生時と現在時の年数差を日単位に換算し、その期間後の太陽の移動量（アーク）を
 * すべてのネイタル天体に加算します。
 */
export function getSolarArcPositions(natalDate, targetDate, natalPositions) {
  try {
    const nDate = natalDate instanceof Date ? natalDate : new Date(natalDate);
    const tDate = targetDate instanceof Date ? targetDate : new Date(targetDate);

    if (isNaN(nDate.getTime()) || isNaN(tDate.getTime())) return natalPositions;

    // 年数の差を計算（ミリ秒単位から換算）
    const diffMs = tDate.getTime() - nDate.getTime();
    if (diffMs < 0) return natalPositions;

    // 1年 = 1日 (セカンダリー・プログレッション) として、経過日数をミリ秒に加算
    // 365.242199 日 = 1年
    const years = diffMs / (365.242199 * 24 * 3600 * 1000);
    const progressedDate = new Date(nDate.getTime() + years * 24 * 3600 * 1000);

    // プログレッション後の太陽の位置を取得
    const natalSun = getPlanetLongitude("Sun", nDate);
    const progressedSun = getPlanetLongitude("Sun", progressedDate);

    if (natalSun === null || progressedSun === null) return natalPositions;

    // ソーラーアーク（太陽の移動量）を算出
    let solarArc = progressedSun - natalSun;
    while (solarArc < 0) solarArc += 360;
    while (solarArc >= 360) solarArc -= 360;

    // すべてのネイタル天体にソーラーアークを加算
    const saPositions = {};
    Object.keys(natalPositions).forEach((p) => {
      if (natalPositions[p] !== null) {
        saPositions[p] = normalizeDegrees(natalPositions[p] + solarArc);
      } else {
        saPositions[p] = null;
      }
    });

    return saPositions;
  } catch (e) {
    console.error("getSolarArcPositions error:", e);
    return natalPositions;
  }
}

export function getHeliocentricLatitude(planet, date) {
  try {
    if (planet === "Sun" || planet === "Moon" || !date) return 0;
    const time = Astronomy.MakeTime(date);
    const body =
      planet === "Earth" ? Astronomy.Body.Earth : PLANET_BODIES[planet];
    if (!body) return 0;
    const vec = Astronomy.HelioVector(body, time);
    const ecl = Astronomy.Ecliptic(vec, time);
    return ecl.elat;
  } catch (e) {
    return 0;
  }
}

export function getAllHeliocentricLatitudes(date) {
  const positions = {};
  const planets = [
    "Mercury",
    "Venus",
    "Earth",
    "Mars",
    "Jupiter",
    "Saturn",
    "Uranus",
    "Neptune",
    "Pluto",
  ];
  if (!date) return positions;
  planets.forEach((p) => {
    positions[p] = getHeliocentricLatitude(p, date);
  });
  return positions;
}

export function getAllDeclinations(date) {
  const positions = {};
  const planets = [
    "Sun",
    "Moon",
    "Mercury",
    "Venus",
    "Mars",
    "Jupiter",
    "Saturn",
    "Uranus",
    "Neptune",
    "Pluto",
  ];
  if (!date) return positions;
  planets.forEach((p) => {
    // getDeclination は後方で定義されているが使用可能
    positions[p] = getDeclination(p, date);
  });
  return positions;
}

export const getAllPlanetDeclinations = getAllDeclinations;

/**
 * 逆行判定ロジック
 * 修正内容：
 * 1. 日付の正規化を行い、チャート描画時のタイムスタンプ形式でも動作を保証しました。
 * 2. 判定間隔（interval）を保持しつつ、黄経360度境界（牡羊座0度）を跨ぐ際の計算ミスを修正しました。
 */
export function isRetrograde(planet, date, isHeliocentric = false) {
  // ヘリオセントリック、太陽、月は逆行しないため false を返却
  if (isHeliocentric === true || planet === "Sun" || planet === "Moon")
    return false;

  try {
    // 日付の正規化
    var d = date instanceof Date ? date : new Date(date);
    if (isNaN(d.getTime())) return false;

    // 天体ごとに適切な判定間隔（前後1時間〜3日）を設定
    const intervals = {
      Mercury: 3600000, // 1時間
      Venus: 7200000, // 2時間
      Mars: 14400000, // 4時間
      Jupiter: 43200000, // 12時間
      Saturn: 86400000, // 1日
      Uranus: 86400000, // 1日
      Neptune: 172800000, // 2日
      Pluto: 259200000, // 3日
    };
    const interval = intervals[planet] || 3600000;

    const time1 = new Date(d.getTime() - interval);
    const time2 = new Date(d.getTime() + interval);

    // ジオセントリック位置を取得
    const lon1 = getPlanetLongitude(planet, time1);
    const lon2 = getPlanetLongitude(planet, time2);

    if (lon1 === null || lon2 === null) return false;

    // 経度差の計算（360度境界をまたぐ場合の補正）
    let diff = lon2 - lon1;
    if (diff > 180) diff -= 360;
    if (diff < -180) diff += 360;

    // 経度が減少（マイナス）していれば逆行
    return diff < 0;
  } catch (e) {
    return false;
  }
}

/**
 * 逆行天体リスト取得 (サイデリアル・ヘリオ対応)
 */
export function getRetrogradePlanets(date, isSidereal = false, isHeliocentric = false) {
  const retrograde = [];
  try {
    RETROGRADE_PLANETS.forEach((planet) => {
      if (isRetrograde(planet, date, isHeliocentric)) {
        const lon = isHeliocentric
          ? getHeliocentricLongitude(planet, date)
          : getPlanetLongitude(planet, date);
        if (lon === null) return;

        // サイデリアルが有効な場合は経度を補正してサインを判定
        let displayLon = lon;
        if (isSidereal) {
          const jd = dateToJulianDay(date);
          const ayan = 23.8528 + ((50.29 / 3600) * (jd - 2451545.0)) / 365.25;
          displayLon = (lon - ayan + 360) % 360;
        }
        retrograde.push({
          planet,
          longitude: displayLon,
          sign: getZodiacSign(displayLon),
        });
      }
    });
  } catch (e) { }
  return retrograde;
}

export function getPlanetDistance(planet, date, isHeliocentric = false) {
  try {
    const time = Astronomy.MakeTime(date);
    const body = PLANET_BODIES[planet];
    if (!body) return 1.0;

    if (isHeliocentric) {
      const vec = Astronomy.HelioVector(body, time);
      return Math.sqrt(vec.x * vec.x + vec.y * vec.y + vec.z * vec.z);
    } else {
      const vec = Astronomy.GeoVector(body, time, true);
      return Math.sqrt(vec.x * vec.x + vec.y * vec.y + vec.z * vec.z);
    }
  } catch (e) {
    return 1.0;
  }
}

export function getPlanetSpeed(planet, date) {
  try {
    const before = new Date(date.getTime() - 12 * 3600000);
    const after = new Date(date.getTime() + 12 * 3600000);
    const lonBefore = getPlanetLongitude(planet, before);
    const lonAfter = getPlanetLongitude(planet, after);
    if (lonBefore === null || lonAfter === null) return null;
    let diff = lonAfter - lonBefore;
    if (diff > 180) diff -= 360;
    if (diff < -180) diff += 360;
    const speedPerDay = diff;
    const isRetrograde = speedPerDay < 0;
    const isStation = Math.abs(speedPerDay) < getStationThreshold(planet);
    return {
      speedPerDay,
      speedPerHour: speedPerDay / 24,
      isRetrograde,
      isStation,
      direction: isRetrograde ? "R" : "D",
    };
  } catch (e) {
    return null;
  }
}

function getStationThreshold(planet) {
  const thresholds = {
    Sun: 0.01,
    Moon: 0.5,
    Mercury: 0.1,
    Venus: 0.05,
    Mars: 0.03,
    Jupiter: 0.01,
    Saturn: 0.005,
    Uranus: 0.002,
    Neptune: 0.001,
    Pluto: 0.001,
  };
  return thresholds[planet] || 0.01;
}

export function getAllPlanetSpeeds(date) {
  const speeds = {};
  const planets = [
    "Sun",
    "Moon",
    "Mercury",
    "Venus",
    "Mars",
    "Jupiter",
    "Saturn",
    "Uranus",
    "Neptune",
    "Pluto",
  ];
  planets.forEach((planet) => {
    speeds[planet] = getPlanetSpeed(planet, date);
  });
  return speeds;
}

export function getAveragePlanetSpeed(planet) {
  const avgSpeeds = {
    Sun: 0.9856,
    Moon: 13.176,
    Mercury: 1.383,
    Venus: 1.2,
    Mars: 0.524,
    Jupiter: 0.083,
    Saturn: 0.034,
    Uranus: 0.012,
    Neptune: 0.006,
    Pluto: 0.004,
  };
  return avgSpeeds[planet] || 0;
}

// =================================================================
// 4. アスペクト・パターン検出
// =================================================================

export function calculateMidpoint(lon1, lon2) {
  const diff = Math.abs(lon1 - lon2);
  let mid;
  if (diff <= 180) {
    mid = (lon1 + lon2) / 2;
  } else {
    // 180度を超える場合は反対側の弧（最短弧）の平均を取る
    mid = (lon1 + lon2 + 360) / 2;
  }
  return normalizeDegrees(mid);
}

export function getMod90(longitude) {
  return ((longitude % 90) + 90) % 90;
}

export function getModality(mod90) {
  if (mod90 < 30) return "Cardinal";
  if (mod90 < 60) return "Fixed";
  return "Mutable";
}

export function calculateOrb(pos1, pos2) {
  let diff = Math.abs(pos1 - pos2);
  if (diff > 45) diff = 90 - diff;
  return diff;
}

// 外惑星の定義
const OUTER_PLANETS = ["Jupiter", "Saturn", "Uranus", "Neptune", "Pluto"];

/**
 * アスペクト判定 (動的Orb対応版)
 */
export function calculateAspect(
  lon1,
  lon2,
  aspectList,
  p1,
  p2,
  customSettings,
) {
  // 引数が渡されない場合のデフォルト設定 (エラー防止ガード)
  const settings = customSettings || {
    majorOrb: 8,
    minorOrb: 2,
    outerPlanetOrb: 1,
    useOuterLimit: false,
  };

  let diff = Math.abs(lon1 - lon2);
  if (diff > 180) diff = 360 - diff;

  // 天体が外惑星同士かどうかの判定
  const isBothOuter =
    p1 !== undefined &&
    p2 !== undefined &&
    OUTER_PLANETS.indexOf(p1) !== -1 &&
    OUTER_PLANETS.indexOf(p2) !== -1;

  for (let i = 0; i < aspectList.length; i++) {
    const aspect = aspectList[i];

    // 1. 分類に応じたベースOrbの決定
    const isMajorAspect =
      ["Conjunction", "Opposition", "Trine", "Square", "Sextile"].indexOf(
        aspect.name,
      ) !== -1;
    let baseOrb =
      isMajorAspect === true ? settings.majorOrb : settings.minorOrb;

    // 2. 外惑星制限の適用 (指定された場合のみ)
    if (settings.useOuterLimit === true && isBothOuter === true) {
      baseOrb = settings.outerPlanetOrb;
    }

    const orbValue = Math.abs(diff - aspect.angle);
    if (orbValue <= baseOrb) {
      return Object.assign({}, aspect, { orb: orbValue, applying: null });
    }
  }
  return null;
}

export function getAllAspects(positions, aspectType = "major") {
  const aspectList = ASPECTS[aspectType] || ASPECTS.major;
  const planets = Object.keys(positions);
  const aspects = [];
  try {
    for (let i = 0; i < planets.length; i++) {
      for (let j = i + 1; j < planets.length; j++) {
        const p1 = planets[i];
        const p2 = planets[j];
        const aspect = calculateAspect(
          positions[p1],
          positions[p2],
          aspectList,
        );
        if (aspect) {
          aspects.push({
            planet1: p1,
            planet2: p2,
            lon1: positions[p1],
            lon2: positions[p2],
            sign1: getZodiacSign(positions[p1]),
            sign2: getZodiacSign(positions[p2]),
            ...aspect,
          });
        }
      }
    }
    aspects.sort((a, b) => a.orb - b.orb);
  } catch (e) {
    console.error("getAllAspects error:", e);
  }
  return aspects;
}

export function searchAspects(options) {
  const {
    planet1 = null,
    planet2 = null,
    aspectType = "major",
    fromDate,
    toDate,
    signFilter = null,
    rxFilter = null,
    maxResults = 100,
  } = options;
  const results = [];
  try {
    let aspectList =
      aspectType === "all"
        ? [...ASPECTS.major, ...ASPECTS.minor]
        : ASPECTS[aspectType] || ASPECTS.major;
    const planets = Object.keys(PLANET_BODIES);
    const pairs = [];
    for (let i = 0; i < planets.length; i++) {
      for (let j = i + 1; j < planets.length; j++) {
        const p1 = planets[i];
        const p2 = planets[j];
        if (planet1 && planet1 !== p1 && planet1 !== p2) continue;
        if (planet2 && planet2 !== p1 && planet2 !== p2) continue;
        if (
          planet1 &&
          planet2 &&
          !(
            (planet1 === p1 && planet2 === p2) ||
            (planet1 === p2 && planet2 === p1)
          )
        )
          continue;
        pairs.push([p1, p2]);
      }
    }
    const daysDiff = Math.ceil((toDate - fromDate) / 86400000);
    const step = daysDiff > 365 ? 2 : 1;
    for (
      let d = 0;
      d <= daysDiff && results.length < maxResults * 2;
      d += step
    ) {
      const checkDate = new Date(fromDate.getTime() + d * 86400000);
      const positions = getAllPlanetLongitudes(checkDate);
      const prevDate = new Date(checkDate.getTime() - step * 86400000);
      const prevPositions = getAllPlanetLongitudes(prevDate);
      for (const [p1, p2] of pairs) {
        let diff = Math.abs(positions[p1] - positions[p2]);
        if (diff > 180) diff = 360 - diff;
        for (const aspect of aspectList) {
          const orb = Math.abs(diff - aspect.angle);
          if (orb <= 1.5) {
            let prevDiff = Math.abs(prevPositions[p1] - prevPositions[p2]);
            if (prevDiff > 180) prevDiff = 360 - prevDiff;
            const prevOrb = Math.abs(prevDiff - aspect.angle);
            if ((prevOrb > orb && orb <= 1.0) || orb <= 0.3) {
              const sign1 = getZodiacSign(positions[p1]);
              const sign2 = getZodiacSign(positions[p2]);
              const rx1 = isRetrograde(p1, checkDate);
              const rx2 = isRetrograde(p2, checkDate);
              if (
                signFilter &&
                sign1.name !== signFilter &&
                sign2.name !== signFilter
              )
                continue;
              if (rxFilter === true && !rx1 && !rx2) continue;
              if (rxFilter === false && (rx1 || rx2)) continue;
              const isDuplicate = results.some(
                (r) =>
                  r.planet1 === p1 &&
                  r.planet2 === p2 &&
                  r.aspect.name === aspect.name &&
                  Math.abs(r.date - checkDate) < 3 * 86400000,
              );
              if (!isDuplicate) {
                results.push({
                  date: new Date(checkDate),
                  planet1: p1,
                  planet2: p2,
                  aspect,
                  orb,
                  sign1,
                  sign2,
                  lon1: positions[p1],
                  lon2: positions[p2],
                  rx1,
                  rx2,
                });
              }
              break;
            }
          }
        }
      }
    }
    results.sort((a, b) => a.orb - b.orb);
  } catch (e) {
    console.error("searchAspects error:", e);
  }
  return results.slice(0, maxResults);
}

/**
 * 複合アスペクト・特殊パターン検出
 * 修正内容：isSidereal と date を受け取り、ステリウム判定などのサイン計算に反映させます。
 */
export function detectSpecialPatterns(allAspects, positions, isSidereal, date) {
  // 引数の初期値設定（オプショナルチェイニング排除）
  if (isSidereal === undefined) isSidereal = false;
  if (date === undefined) date = new Date();

  var patterns = [];
  var planets = Object.keys(positions);
  var map = {};

  // アスペクトマップの作成
  allAspects.forEach(function (a) {
    var p1 = a.planet1;
    var p2 = a.planet2;
    var aName = a.aspect && a.aspect.name ? a.aspect.name : a.name;

    if (map[p1] === undefined) map[p1] = {};
    if (map[p2] === undefined) map[p2] = {};
    map[p1][p2] = aName;
    map[p2][p1] = aName;
  });

  var has = function (p1, p2, type) {
    return map[p1] !== undefined && map[p1][p2] === type;
  };

  // 1. 太陽との関係 (Cazimi / Combust)
  if (positions["Sun"] !== undefined) {
    var sunLon = positions["Sun"];
    var targetPlanets = [
      "Moon",
      "Mercury",
      "Venus",
      "Mars",
      "Jupiter",
      "Saturn",
    ];

    targetPlanets.forEach(function (planet) {
      if (positions[planet] === undefined) return;
      var diff = Math.abs(sunLon - positions[planet]);
      if (diff > 180) diff = 360 - diff;

      if (diff <= 17) {
        if (diff < 0.2833) {
          patterns.push({
            name: "Cazimi (カジミ)",
            planets: ["Sun", planet],
            desc: planet + "が太陽の心臓域にあり、力が最高潮に達しています",
            type: "benefit",
          });
        } else if (diff < 8.5) {
          patterns.push({
            name: "Combust (コンバスト)",
            planets: ["Sun", planet],
            desc: planet + "が太陽の熱で焼かれ、力が弱まっています",
            type: "hard",
          });
        }
      }
    });
  }

  // 2. Stellium (ステリウム) - サイン判定にサイデリアル設定を適用
  var signGroups = {};
  planets.forEach(function (p) {
    if (MAJOR_PLANETS.indexOf(p) === -1) return;
    // getZodiacSignにフラグを渡してサイデリアル対応させる
    var signData = getZodiacSign(positions[p], isSidereal, date);
    var signName = signData !== null ? signData.name : "Unknown";

    if (signGroups[signName] === undefined) signGroups[signName] = [];
    signGroups[signName].push(p);
  });

  var signEntries = Object.keys(signGroups);
  for (var i = 0; i < signEntries.length; i++) {
    var signName = signEntries[i];
    var group = signGroups[signName];
    if (group.length >= 3) {
      patterns.push({
        name: "Stellium in " + signName,
        planets: group,
        desc: signName + "座に" + group.length + "天体が集中しています",
        type: "neutral",
      });
    }
  }

  // 3. 幾何学パターン (Grand Trine, T-Square, Yod)
  var pList = planets.filter(function (p) {
    return MAJOR_PLANETS.indexOf(p) !== -1;
  });
  for (var i = 0; i < pList.length; i++) {
    for (var j = i + 1; j < pList.length; j++) {
      for (var k = j + 1; k < pList.length; k++) {
        var p1 = pList[i],
          p2 = pList[j],
          p3 = pList[k];

        // Grand Trine
        if (
          has(p1, p2, "Trine") &&
          has(p2, p3, "Trine") &&
          has(p3, p1, "Trine")
        ) {
          patterns.push({
            name: "Grand Trine",
            planets: [p1, p2, p3],
            desc: "幸運の大三角形",
            type: "benefit",
          });
        }

        // T-Square
        if (
          has(p1, p2, "Opposition") &&
          has(p3, p1, "Square") &&
          has(p3, p2, "Square")
        ) {
          patterns.push({
            name: "T-Square",
            planets: [p1, p2, p3],
            desc: p3 + "頂点のTスクエア",
            type: "hard",
          });
        } else if (
          has(p2, p3, "Opposition") &&
          has(p1, p2, "Square") &&
          has(p1, p3, "Square")
        ) {
          patterns.push({
            name: "T-Square",
            planets: [p1, p2, p3],
            desc: p1 + "頂点のTスクエア",
            type: "hard",
          });
        } else if (
          has(p1, p3, "Opposition") &&
          has(p2, p1, "Square") &&
          has(p2, p3, "Square")
        ) {
          patterns.push({
            name: "T-Square",
            planets: [p1, p2, p3],
            desc: p2 + "頂点のTスクエア",
            type: "hard",
          });
        }

        // Yod
        if (
          has(p1, p2, "Sextile") &&
          has(p3, p1, "Quincunx") &&
          has(p3, p2, "Quincunx")
        ) {
          patterns.push({
            name: "Yod",
            planets: [p1, p2, p3],
            desc: p3 + "頂点のヨード",
            type: "mystic",
          });
        }
      }
    }
  }

  // 重複排除ロジック
  var uniquePatterns = [];
  var seen = {};
  patterns.forEach(function (p) {
    var sortedPlanets = p.planets.slice().sort().join("-");
    var key = p.name + ":" + sortedPlanets;
    if (seen[key] === undefined) {
      seen[key] = true;
      uniquePatterns.push(p);
    }
  });

  return uniquePatterns;
}

// =================================================================
// 5. 日次・週間イベント取得
// =================================================================

function getEclipseType(kind, category) {
  const k = String(kind).toLowerCase();
  if (category === "solar") {
    if (k.includes("total"))
      return { type: "皆既日食", symbol: "🌑", japaneseKind: "皆既" };
    if (k.includes("annular"))
      return { type: "金環日食", symbol: "💍", japaneseKind: "金環" };
    if (k.includes("hybrid"))
      return { type: "金環皆既日食", symbol: "🌓", japaneseKind: "金環皆既" };
    if (k.includes("partial"))
      return { type: "部分日食", symbol: "🌘", japaneseKind: "部分" };
    return { type: "日食", symbol: "🌑", japaneseKind: "不明" };
  } else {
    if (k.includes("total"))
      return { type: "皆既月食", symbol: "🔴", japaneseKind: "皆既" };
    if (k.includes("partial"))
      return { type: "部分月食", symbol: "🌗", japaneseKind: "部分" };
    if (k.includes("penumbral"))
      return { type: "半影月食", symbol: "⚫", japaneseKind: "半影" };
    return { type: "月食", symbol: "🌕", japaneseKind: "不明" };
  }
}

/**
 * 1日の天体イベント算出
 * 修正内容：isSidereal フラグを detectSpecialPatterns へ確実に引き渡します。
 */
export function getDailyEvents(
  date,
  natalPositions,
  isHeliocentric,
  isSidereal,
  showExtendedPoints,
) {
  if (isHeliocentric === undefined) isHeliocentric = false;
  if (isSidereal === undefined) isSidereal = false;
  if (showExtendedPoints === undefined) showExtendedPoints = false;
  if (natalPositions === undefined) natalPositions = null;

  var events = [];
  try {
    var startOfDay = new Date(
      Date.UTC(
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        0,
        0,
        0,
      ),
    );
    var endOfDay = new Date(
      Date.UTC(
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        23,
        59,
        59,
      ),
    );

    var posStart = isHeliocentric
      ? getAllHeliocentricLongitudes(startOfDay)
      : getAllPlanetLongitudes(startOfDay);
    var posEnd = isHeliocentric
      ? getAllHeliocentricLongitudes(endOfDay)
      : getAllPlanetLongitudes(endOfDay);

    // モードに応じた天体フィルタリング
    var planetKeys = Object.keys(posStart).filter(function (p) {
      return isHeliocentric === true
        ? p !== "Sun" && p !== "Moon"
        : p !== "Earth";
    });

    // --- イングレス (サイン移動) ---
    planetKeys.forEach(function (p) {
      var s1 = getZodiacSign(posStart[p], isSidereal, startOfDay);
      var s2 = getZodiacSign(posEnd[p], isSidereal, endOfDay);
      if (s1 !== null && s2 !== null && s1.name !== s2.name) {
        events.push({
          type: "ingress",
          planet: p,
          toSign: s2,
          name: p + " " + s2.name + "入り",
          symbol: "✨",
        });
      }
    });

    // --- アスペクト ---
    var dayAspects = [];
    var majorAspectsList = ASPECTS.major;
    for (var i = 0; i < planetKeys.length; i++) {
      for (var j = i + 1; j < planetKeys.length; j++) {
        var p1 = planetKeys[i],
          p2 = planetKeys[j];
        var lon1 = posStart[p1],
          lon2 = posStart[p2];
        if (lon1 === null || lon2 === null) continue;

        var aspect = calculateAspect(lon1, lon2, majorAspectsList, p1, p2);
        if (aspect !== null && aspect.orb <= 2.0) {
          var aspectData = {
            type: "aspect",
            planet1: p1,
            planet2: p2,
            aspect: aspect,
            name: p1 + " " + aspect.name + " " + p2,
            symbol: aspect.symbol,
            orb: aspect.orb,
          };
          events.push(aspectData);
          dayAspects.push(aspectData);
        }
      }
    }

    // --- 複合パターン (isSiderealを渡す) ---
    var patterns = detectSpecialPatterns(
      dayAspects,
      posStart,
      isSidereal,
      startOfDay,
    );
    patterns.forEach(function (p) {
      events.push({
        type: "pattern",
        name: p.name,
        description: p.desc,
        planets: p.planets,
        symbol: p.type === "benefit" ? "⭐" : p.type === "hard" ? "🔥" : "🌌",
      });
    });

    // --- ステーション ---
    planetKeys.forEach(function (p) {
      if (isHeliocentric === true || p === "Sun" || p === "Moon") return;
      var speedStart = getPlanetSpeed(p, startOfDay);
      var speedEnd = getPlanetSpeed(p, endOfDay);
      if (speedStart !== null && speedEnd !== null) {
        if (speedStart.speedPerDay > 0 && speedEnd.speedPerDay < 0) {
          events.push({
            type: "station",
            planet: p,
            name: p + " 逆行開始 (SR)",
            symbol: "℞",
          });
        } else if (speedStart.speedPerDay < 0 && speedEnd.speedPerDay > 0) {
          events.push({
            type: "station",
            planet: p,
            name: p + " 順行開始 (SD)",
            symbol: "🔄",
          });
        }
      }
    });
  } catch (e) {
    console.error("getDailyEvents error:", e);
  }
  return events;
}
/**
 * getCelestialEvents 関数ブロック
 * 役割：特定の日付における天体コンディション（月相、宿曜、VOC、OOB等）を取得
 * 修正：宿曜の計算ロジックを追加
 */
export function getCelestialEvents(
  date,
  isHeliocentric,
  isSidereal,
  showExtendedPoints,
) {
  if (isHeliocentric === undefined) isHeliocentric = false;
  if (isSidereal === undefined) isSidereal = false;
  if (showExtendedPoints === undefined) showExtendedPoints = false;

  try {
    // 宿曜 (27宿) の計算
    var moonLon = getPlanetLongitude("Moon", date);
    var sukuyoData = null;
    if (moonLon !== null && moonLon !== undefined) {
      var names = [
        "婁宿",
        "胃宿",
        "昴宿",
        "畢宿",
        "觜宿",
        "参宿",
        "井宿",
        "鬼宿",
        "柳宿",
        "星宿",
        "張宿",
        "翼宿",
        "軫宿",
        "角宿",
        "亢宿",
        "氐宿",
        "房宿",
        "心宿",
        "尾宿",
        "箕宿",
        "斗宿",
        "女宿",
        "虚宿",
        "危宿",
        "室宿",
        "壁宿",
        "奎宿",
      ];
      var idx = Math.floor(moonLon / (360 / 27)) % 27;
      sukuyoData = { name: names[idx], symbol: names[idx].charAt(0) };
    }

    // 既存のイベント取得と統合して返す
    return {
      moonPhase: getMoonPhase(date),
      moonIllumination: getMoonIllumination(date),
      moonVOC: getMoonVOC(date),
      retrogrades: getRetrogradePlanets(date, isSidereal, isHeliocentric),
      oobPlanets: getOOBPlanets(date, isHeliocentric),
      sukuyo: sukuyoData, // 追加
      ingresses: getIngresses(
        date,
        3,
        10,
        isHeliocentric,
        isSidereal,
        showExtendedPoints,
      ),
      eclipses: getEclipses(date, 365),
      nextPhases: getNextPhases(date, 4),
      solarTerms: getSolarTerms(date),
      solarTermEvents: getSolarTermEvents(date, 7, 30),
    };
  } catch (e) {
    console.error("getCelestialEvents error:", e);
    return null;
  }
}

/**
 * 週間カレンダー取得 (UTC基準)
 */
export function getWeeklyCalendar(
  startDate,
  natalPositions = null,
  isHeliocentric = false,
  isSidereal = false,
  showExtendedPoints = false,
) {
  const calendar = [];
  try {
    for (let i = 0; i < 7; i++) {
      const date = new Date(startDate.getTime() + i * 86400000);
      const events = getDailyEvents(
        date,
        natalPositions,
        isHeliocentric,
        isSidereal,
        showExtendedPoints,
      );

      // getUTCDay() を使用してローカル環境に左右されない曜日を取得
      const dayLabels = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
      calendar.push({
        date,
        dayOfWeek: dayLabels[date.getUTCDay()],
        events,
      });
    }
  } catch (e) {
    console.error("getWeeklyCalendar error:", e);
  }
  return calendar;
}

// --- 修正版：正確な ASC/MC および プラシーダス・ハウス計算 ---

export function getGMST(date) {
  const jd = dateToJulianDay(date);
  const T = (jd - 2451545.0) / 36525.0;
  let gmst =
    280.46061837 +
    360.98564736629 * (jd - 2451545.0) +
    0.000387933 * T * T -
    (T * T * T) / 38710000;
  return ((gmst % 360) + 360) % 360;
}

export function getLST(date, longitude) {
  const gmst = getGMST(date);
  // 東経をプラスとして計算
  return (gmst + (longitude % 360) + 360) % 360;
}

export function getObliquity(date) {
  const jd = dateToJulianDay(date);
  const T = (jd - 2451545.0) / 36525.0;
  return (
    23.439291 - 0.0130042 * T - 0.00000016 * T * T + 0.000000504 * T * T * T
  );
}

export function getMC(date, longitude) {
  const lst = getLST(date, longitude);
  const epsilon = (getObliquity(date) * Math.PI) / 180;
  const lstRad = (lst * Math.PI) / 180;

  // atan2 を使用して象限を正しく判定
  let mc = Math.atan2(Math.sin(lstRad), Math.cos(lstRad) * Math.cos(epsilon));
  return ((mc * 180) / Math.PI + 360) % 360;
}

export function getASC(date, latitude, longitude) {
  const lst = getLST(date, longitude);
  const eps = (getObliquity(date) * Math.PI) / 180;
  const phi = (latitude * Math.PI) / 180;
  const ramc = (lst * Math.PI) / 180;

  // 正確なアセンダント公式 (符号の修正済)
  const y = Math.cos(ramc);
  const x = -(Math.sin(ramc) * Math.cos(eps) + Math.tan(phi) * Math.sin(eps));

  let asc = Math.atan2(y, x);
  return ((asc * 180) / Math.PI + 360) % 360;
}

/**
 * プラシーダス反復計算ヘルパー
 */
function solvePlacidus(deg, phi, ramc, eps, isLower) {
  const epsRad = (eps * Math.PI) / 180;
  const phiRad = (phi * Math.PI) / 180;
  const f = deg / 90;
  let lon = ramc + (deg * Math.PI) / 180;

  for (let i = 0; i < 10; i++) {
    let decl = Math.asin(Math.sin(epsRad) * Math.sin(lon));
    let ad = Math.asin(
      Math.max(-1, Math.min(1, Math.tan(phiRad) * Math.tan(decl))),
    );
    lon = ramc + f * (Math.PI / 2 + (isLower ? -ad : ad));
  }

  let ra = lon;
  let y = Math.sin(ra);
  let x = Math.cos(ra) * Math.cos(epsRad);
  return ((Math.atan2(y, x) * 180) / Math.PI + 360) % 360;
}

export function getAscendantMC(date, latitude, longitude) {
  try {
    const asc = getASC(date, latitude, longitude);
    const mc = getMC(date, longitude);
    return { ascendant: asc, mc: mc, lst: getLST(date, longitude) };
  } catch (error) {
    return { ascendant: 0, mc: 0, lst: 0 };
  }
}

export function getPlacidusHouses(
  date,
  latitude,
  longitude,
  system = "placidus",
) {
  const asc = getASC(date, latitude, longitude);
  const mc = getMC(date, longitude);
  const ramc = (getLST(date, longitude) * Math.PI) / 180;
  const eps = getObliquity(date);

  const cusps = new Array(12);

  if (system === "equal") {
    // 等分ハウス：ASCから30度ずつ
    for (let i = 0; i < 12; i++) cusps[i] = (asc + i * 30) % 360;
  } else {
    // 本物のプラシーダス計算
    cusps[0] = asc; // H1
    cusps[9] = mc; // H10
    cusps[3] = (mc + 180) % 360; // H4
    cusps[6] = (asc + 180) % 360; // H7

    cusps[10] = solvePlacidus(30, latitude, ramc, eps, false); // H11
    cusps[11] = solvePlacidus(60, latitude, ramc, eps, false); // H12
    cusps[1] = solvePlacidus(120, latitude, ramc, eps, false); // H2
    cusps[2] = solvePlacidus(150, latitude, ramc, eps, false); // H3

    cusps[4] = (cusps[10] + 180) % 360; // H5
    cusps[5] = (cusps[11] + 180) % 360; // H6
    cusps[7] = (cusps[1] + 180) % 360; // H8
    cusps[8] = (cusps[2] + 180) % 360; // H9
  }

  return { asc, mc, cusps, ic: cusps[3], dsc: cusps[6] };
}

/**
 * NorthNode の計算（Mean Node: 平均位置 基準）
 */
export function getMeanNode(date) {
  if (!date) return null;
  const jd = date.getTime() / 86400000 + 2440587.5;
  const T = (jd - 2451545.0) / 36525.0;
  let node = 125.0445479 - 1934.1362891 * T + 0.0020754 * T * T + (T * T * T) / 467441;
  return ((node % 360) + 360) % 360;
}

/**
 * NorthNode の計算（True Node: 真位置 基準）
 * Mean Node に主要な摂動項を加算して算出します。
 */
export function getTrueNodeLongitude(date) {
  if (!date) return null;
  const meanNode = getMeanNode(date);
  const T = (date.getTime() / 86400000 + 2440587.5 - 2451545.0) / 36525.0;

  // 各平均要素（離角D, 太陽近点引数M, 月近点引数M', 緯度引数F）
  const D = normalizeDegrees(297.8501921 + 445267.1114034 * T);
  const M = normalizeDegrees(357.5291092 + 35999.0502909 * T);
  const F = normalizeDegrees(93.2720950 + 483202.0175233 * T);

  const d2r = Math.PI / 180;
  // 主要な補正項（度数単位）
  let corr = -1.4979 * Math.sin((2 * D - 2 * F) * d2r);
  corr -= 0.1503 * Math.sin(M * d2r);
  corr -= 0.1226 * Math.sin(2 * D * d2r);
  corr += 0.1220 * Math.sin(2 * F * d2r);
  corr -= 0.0225 * Math.sin((2 * D - M) * d2r);

  return normalizeDegrees(meanNode + corr);
}

/**
 * NorthNode の取得（真位置を返すように変更）
 */
export function getNorthNodeLongitude(date) {
  return getTrueNodeLongitude(date);
}

/**
 * SouthNode の取得 (NorthNode の対面 180度)
 */
export function getSouthNode(northNodeLon) {
  if (northNodeLon === null || northNodeLon === undefined) return null;
  return (northNodeLon + 180) % 360;
}

/**
 * SouthNode の度数取得（日付から直接計算用）
 */
export function getSouthNodeLongitude(date) {
  return getSouthNode(getNorthNodeLongitude(date));
}
/**
 * 3Dケプラーソルバー: 座標系の一貫性を保持
 */
function solveKepler3D(date, el, isHelio = false) {
  if (!date || isNaN(date.getTime())) return 0;
  const time = Astronomy.MakeTime(date);

  // ★修正★: time.tt は既にJ2000.0からの経過日数（TT基準）なので、そのまま使用
  const d = time.tt;
  const t = d / 36525.0;

  // 1. 変動率を適用した軌道要素の計算
  const curL = normalizeDegrees(el.L + el.rateL * t);
  const curW = normalizeDegrees(el.w + el.rateW * t);
  const curNode = normalizeDegrees(el.node + el.rateNode * t);

  // 2. 平均近点離角 M (L - w)
  const M_deg = normalizeDegrees(curL - curW);
  const M_rad = M_deg * (Math.PI / 180);

  // 3. ケプラー方程式を解く
  let E_val = M_rad;
  for (let i = 0; i < 15; i++) {
    E_val =
      E_val -
      (E_val - el.e * Math.sin(E_val) - M_rad) / (1 - el.e * Math.cos(E_val));
  }

  // 4. 軌道面内の座標 (AU)
  const x_orb = el.a * (Math.cos(E_val) - el.e);
  const y_orb = el.a * Math.sqrt(1 - el.e * el.e) * Math.sin(E_val);

  // 5. 黄道座標(J2000 Ecliptic)への変換
  const node_rad = curNode * (Math.PI / 180);
  const arg_peri_rad = normalizeDegrees(curW - curNode) * (Math.PI / 180);
  const i_rad = el.i * (Math.PI / 180);

  const cosN = Math.cos(node_rad),
    sinN = Math.sin(node_rad);
  const cosW = Math.cos(arg_peri_rad),
    sinW = Math.sin(arg_peri_rad);
  const cosI = Math.cos(i_rad),
    sinI = Math.sin(i_rad);

  const xh_ecl =
    (cosN * cosW - sinN * sinW * cosI) * x_orb +
    (-cosN * sinW - sinN * cosW * cosI) * y_orb;
  const yh_ecl =
    (sinN * cosW + cosN * sinW * cosI) * x_orb +
    (-sinN * sinW + cosN * cosW * cosI) * y_orb;
  const zh_ecl = sinW * sinI * x_orb + cosW * sinI * y_orb;

  if (isHelio === true) {
    // Rotation_ECL_ECL は存在しないため、計算済みの黄道成分をそのまま使用
    return normalizeDegrees(Math.atan2(yh_ecl, xh_ecl) * (180 / Math.PI));
  }

  // 6. 赤道座標(J2000 Equatorial / ICRF)へ回転
  const eps0 = 23.4392911 * (Math.PI / 180);
  const xh_eq = xh_ecl;
  const yh_eq = yh_ecl * Math.cos(eps0) - zh_ecl * Math.sin(eps0);
  const zh_eq = yh_ecl * Math.sin(eps0) + zh_ecl * Math.cos(eps0);

  // 7. 地球のベクトル(J2000 Equatorial)を取得
  const earthHelio = Astronomy.HelioVector(Astronomy.Body.Earth, time);
  const x_geo_eq = xh_eq - earthHelio.x;
  const y_geo_eq = yh_eq - earthHelio.y;
  const z_geo_eq = zh_eq - earthHelio.z;

  // 8. J2000赤道 → 当日黄道(Tropical Ecliptic)へ一括変換
  const matrix = Astronomy.Rotation_EQJ_ECL(time);
  const vec_j2000 = { x: x_geo_eq, y: y_geo_eq, z: z_geo_eq };
  const vec_ecl = Astronomy.RotateVector(matrix, vec_j2000);

  return normalizeDegrees(Math.atan2(vec_ecl.y, vec_ecl.x) * (180 / Math.PI));
}

export const getExtendedPoints = (
  date,
  latitude = null,
  longitude = null,
  houseSystem = "placidus",
) => {
  const results = {};
  try {
    const nn = getNorthNodeLongitude(date);
    results.NorthNode = nn;
    results.SouthNode = getSouthNode(nn);

    if (latitude !== null && longitude !== null) {
      const houses = getPlacidusHouses(date, latitude, longitude, houseSystem);
      results.ASC = houses.asc;
      results.MC = houses.mc;
      results.DSC = houses.dsc;
      results.IC = houses.ic;
      // 12個の尖点をすべて返却するように修正
      houses.cusps.forEach((c, i) => {
        results["H" + (i + 1)] = c;
      });
    }
  } catch (e) {
    console.error("getExtendedPoints error:", e);
  }
  return results;
};

export function getAllPlanetLongitudesExtended(
  date,
  latitude = null,
  longitude = null,
) {
  const positions = getAllPlanetLongitudes(date);
  // ノードとアングルを常にマージ
  const extended = getExtendedPoints(date, latitude, longitude);
  return Object.assign({}, positions, extended);
}
// =================================================================
// 7. サロス周期
// =================================================================

export function calculateNextSaros(date) {
  try {
    const time = Astronomy.MakeTime(date);
    const nextSolar = Astronomy.SearchGlobalSolarEclipse(time);
    const nextLunar = Astronomy.SearchLunarEclipse(time);
    let startEclipse = null;
    let type = "";
    if (nextSolar && nextLunar) {
      if (nextSolar.peak.date < nextLunar.peak.date) {
        startEclipse = nextSolar;
        type = "solar";
      } else {
        startEclipse = nextLunar;
        type = "lunar";
      }
    } else if (nextSolar) {
      startEclipse = nextSolar;
      type = "solar";
    } else if (nextLunar) {
      startEclipse = nextLunar;
      type = "lunar";
    }
    if (!startEclipse) return null;
    const sarosDaysApprox = 6585.32;
    const futureDate = new Date(
      startEclipse.peak.date.getTime() + (sarosDaysApprox - 5) * 86400000,
    );
    const futureTime = Astronomy.MakeTime(futureDate);
    let endEclipse = null;
    if (type === "solar") {
      endEclipse = Astronomy.SearchGlobalSolarEclipse(futureTime);
    } else {
      endEclipse = Astronomy.SearchLunarEclipse(futureTime);
    }
    if (!endEclipse) return null;
    const msDiff =
      endEclipse.peak.date.getTime() - startEclipse.peak.date.getTime();
    const daysDiff = msDiff / (1000 * 60 * 60 * 24);
    return {
      type: type === "solar" ? "日食" : "月食",
      start: { date: startEclipse.peak.date, kind: startEclipse.kind },
      end: { date: endEclipse.peak.date, kind: endEclipse.kind },
      diff: { days: daysDiff, text: formatTimeDiff(msDiff) },
      theoretical: 6585.3211,
    };
  } catch (e) {
    console.error("calculateNextSaros error:", e);
    return null;
  }
}

function formatTimeDiff(ms) {
  const seconds = Math.floor(ms / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);
  const years = Math.floor(days / 365.2422);
  const remainingDays = Math.floor(days - years * 365.2422);
  const remainingHours = hours % 24;
  const remainingMinutes = minutes % 60;
  return `${years}年 ${remainingDays}日 ${remainingHours}時間 ${remainingMinutes}分`;
}

// =================================================================
// 8. 惑星リターン（回帰）
// =================================================================

export function calculateNextPlanetReturn(planet, startDate, natalLon) {
  try {
    const period = ORBITAL_PERIODS[planet];
    if (!period) return null;
    const searchLimitDays = Math.min(period * 1.2, 365 * 100);
    const endDate = new Date(startDate.getTime() + searchLimitDays * 86400000);
    let stepDays = 1;
    if (planet === "Moon") stepDays = 0.1;
    else if (planet === "Saturn") stepDays = 5;
    else if (["Uranus", "Neptune", "Pluto"].includes(planet)) stepDays = 10;
    let currentCheck = new Date(startDate);
    let prevLon = getPlanetLongitude(planet, currentCheck);
    const getDiff = (lon) => {
      let d = lon - natalLon;
      while (d <= -180) d += 360;
      while (d > 180) d -= 360;
      return d;
    };
    let prevDiff = getDiff(prevLon);
    while (currentCheck <= endDate) {
      const nextCheck = new Date(currentCheck.getTime() + stepDays * 86400000);
      const nextLon = getPlanetLongitude(planet, nextCheck);
      const nextDiff = getDiff(nextLon);
      if (
        prevDiff < 0 &&
        nextDiff >= 0 &&
        Math.abs(nextDiff - prevDiff) < 180
      ) {
        return findExactReturnTime(planet, currentCheck, nextCheck, natalLon);
      }
      currentCheck = nextCheck;
      prevLon = nextLon;
      prevDiff = nextDiff;
    }
    return null;
  } catch (e) {
    console.error(`calculateNextPlanetReturn error for ${planet}:`, e);
    return null;
  }
}

function findExactReturnTime(planet, t1, t2, targetLon) {
  let low = t1.getTime();
  let high = t2.getTime();
  for (let i = 0; i < 20; i++) {
    const mid = (low + high) / 2;
    const midDate = new Date(mid);
    const midLon = getPlanetLongitude(planet, midDate);
    let diff = midLon - targetLon;
    while (diff <= -180) diff += 360;
    while (diff > 180) diff -= 360;
    if (diff < 0) low = mid;
    else high = mid;
  }
  return new Date(high);
}

export function isReturnActive(transitLon, natalLon, orb = 3) {
  let diff = Math.abs(transitLon - natalLon);
  if (diff > 180) diff = 360 - diff;
  return diff <= orb;
}

// =================================================================
// 9. その他イベント・分析
// =================================================================

export function getMoonIllumination(date) {
  try {
    const sunLon = getPlanetLongitude("Sun", date);
    const moonLon = getPlanetLongitude("Moon", date);
    let phase = moonLon - sunLon;
    if (phase < 0) phase += 360;
    const fraction = (1 - Math.cos((phase * Math.PI) / 180)) / 2;
    return {
      fraction: fraction,
      percent: Math.round(fraction * 100),
      angle: phase,
    };
  } catch (e) {
    return { fraction: 0, percent: 0, angle: 0 };
  }
}

export function getMoonPhase(date) {
  try {
    const sunLon = getPlanetLongitude("Sun", date);
    const moonLon = getPlanetLongitude("Moon", date);
    const nodeLon = getNorthNodeLongitude(date);
    
    let phase = moonLon - sunLon;
    if (phase < 0) phase += 360;
    
    // ノードとの距離を計算（日食・月食判定用）
    let distNodeN = Math.abs(moonLon - nodeLon);
    if (distNodeN > 180) distNodeN = 360 - distNodeN;
    let distNodeS = Math.abs(moonLon - ((nodeLon + 180) % 360));
    if (distNodeS > 180) distNodeS = 360 - distNodeS;
    const minNodeDist = Math.min(distNodeN, distNodeS);

    let phaseName, phaseSymbol;
    let isEclipse = false;
    let eclipseType = null;

    if (phase < 22.5 || phase >= 337.5) {
      phaseName = "New Moon";
      phaseSymbol = "🌑";
      // 新月かつノード近傍なら日食
      if (minNodeDist < 18.5) {
        isEclipse = true;
        eclipseType = minNodeDist < 12.2 ? "Total Solar Eclipse(日食)" : "Partial Solar Eclipse(部分日食)";
      }
    } else if (phase < 67.5) {
      phaseName = "Waxing Crescent";
      phaseSymbol = "🌒";
    } else if (phase < 112.5) {
      phaseName = "First Quarter";
      phaseSymbol = "🌓";
    } else if (phase < 157.5) {
      phaseName = "Waxing Gibbous";
      phaseSymbol = "🌔";
    } else if (phase < 202.5) {
      phaseName = "Full Moon";
      phaseSymbol = "🌕";
      // 満月かつノード近傍なら月食
      if (minNodeDist < 12.2) {
        isEclipse = true;
        eclipseType = minNodeDist < 9.5 ? "Total Lunar Eclipse(月食)" : "Partial Lunar Eclipse(部分月食)";
      }
    } else if (phase < 247.5) {
      phaseName = "Waning Gibbous";
      phaseSymbol = "🌖";
    } else if (phase < 292.5) {
      phaseName = "Last Quarter";
      phaseSymbol = "🌗";
    } else {
      phaseName = "Waning Crescent";
      phaseSymbol = "🌘";
    }
    return { angle: phase, name: phaseName, symbol: phaseSymbol, isEclipse, eclipseType };
  } catch (e) {
    return { angle: 0, name: "Unknown", symbol: "🌑", isEclipse: false, eclipseType: null };
  }
}

export function getMoonVOC(date) {
  try {
    const moonLon = getPlanetLongitude("Moon", date);
    const currentSign = getZodiacSign(moonLon);
    const signEnd = (Math.floor(moonLon / 30) + 1) * 30;
    const degreesToSignEnd = signEnd - moonLon;
    const hoursToSignEnd = (degreesToSignEnd / 13.2) * 24;
    const signChangeTime = new Date(date.getTime() + hoursToSignEnd * 3600000);
    const positions = getAllPlanetLongitudes(date);
    const majorAspects = ASPECTS.major;
    const planets = [
      "Sun",
      "Mercury",
      "Venus",
      "Mars",
      "Jupiter",
      "Saturn",
      "Uranus",
      "Neptune",
      "Pluto",
    ];
    let hasCurrentAspect = false;
    let lastAspectInfo = null;
    planets.forEach((planet) => {
      const aspect = calculateAspect(moonLon, positions[planet], majorAspects);
      if (aspect && aspect.orb <= 1) {
        hasCurrentAspect = true;
        lastAspectInfo = { planet, aspect };
      }
    });
    const isVOC = !hasCurrentAspect && degreesToSignEnd < 10;
    return {
      isVOC,
      currentSign,
      moonLongitude: moonLon,
      degreesToSignEnd,
      estimatedSignChange: signChangeTime,
      lastAspect: lastAspectInfo,
    };
  } catch (e) {
    return {
      isVOC: false,
      currentSign: ZODIAC_SIGNS[0],
      moonLongitude: 0,
      degreesToSignEnd: 30,
      estimatedSignChange: new Date(),
      lastAspect: null,
    };
  }
}

export function getNextPhases(date, count = 4) {
  const phases = [];
  try {
    const phaseMap = {
      0: { name: "新月", symbol: "🌑" },
      90: { name: "上弦の月", symbol: "🌓" },
      180: { name: "満月", symbol: "🌕" },
      270: { name: "下弦の月", symbol: "🌗" },
    };
    let searchTime = Astronomy.MakeTime(date);
    const currentLon =
      getPlanetLongitude("Moon", date) - getPlanetLongitude("Sun", date);
    let nextTargetAngle = 0;
    const normalizedLon = normalizeDegrees(currentLon);
    if (normalizedLon < 90) nextTargetAngle = 90;
    else if (normalizedLon < 180) nextTargetAngle = 180;
    else if (normalizedLon < 270) nextTargetAngle = 270;
    else nextTargetAngle = 0;
    for (let i = 0; i < count; i++) {
      const phaseEvent = Astronomy.SearchMoonPhase(
        nextTargetAngle,
        searchTime,
        30,
      );
      if (phaseEvent) {
        phases.push({
          name: phaseMap[nextTargetAngle].name,
          symbol: phaseMap[nextTargetAngle].symbol,
          date: phaseEvent.date,
          angle: nextTargetAngle,
        });
        searchTime = Astronomy.MakeTime(
          new Date(phaseEvent.date.getTime() + 60000),
        );
        nextTargetAngle = (nextTargetAngle + 90) % 360;
      } else break;
    }
  } catch (e) { }
  return phases;
}

export function getLunarApsis(date, daysBefore = 30, daysAfter = 30) {
  const events = [];
  try {
    const endDate = new Date(date.getTime() + daysAfter * 86400000);
    let searchDate = new Date(date.getTime() - daysBefore * 86400000);
    let loopCount = 0;
    while (searchDate < endDate && loopCount < 10) {
      loopCount++;
      const apsis = Astronomy.SearchLunarApsis(searchDate);
      if (apsis && apsis.time) {
        if (apsis.time.date >= endDate) break;
        const dist = apsis.dist_km || apsis.dist_au * 149597870.7;
        events.push({
          type: apsis.kind === 0 ? "perigee" : "apogee",
          name: "   ",
          symbol: " ",
          date: apsis.time.date,
          distance: dist,
        });
        searchDate = new Date(apsis.time.date.getTime() + 7 * 86400000);
      } else {
        searchDate = new Date(searchDate.getTime() + 14 * 86400000);
      }
    }
    events.sort((a, b) => a.date - b.date);
  } catch (e) { }
  return events;
}

export function getMoonDistance(date) {
  try {
    // ★ 修正：MakeTime を使用し、天体IDに Body.Moon を使用
    const time = Astronomy.MakeTime(date);
    const moonVector = Astronomy.GeoVector(Astronomy.Body.Moon, time, true);

    const dist_au = Math.sqrt(
      moonVector.x * moonVector.x +
      moonVector.y * moonVector.y +
      moonVector.z * moonVector.z,
    );
    const dist_km = dist_au * 149597870.7;
    const avg = 384400;
    let status = "average";
    if (dist_km < avg - 10000) status = "close";
    else if (dist_km > avg + 10000) status = "far";
    return {
      distance_km: dist_km,
      distance_au: dist_au,
      status: status,
      percentFromAvg: (((dist_km - avg) / avg) * 100).toFixed(2),
    };
  } catch (e) {
    return null;
  }
}

export function getSolarTerms(date) {
  try {
    const sunLon = getPlanetLongitude("Sun", date);
    let currentTerm = null,
      nextTerm = null;
    for (let i = 0; i < SOLAR_TERMS.length; i++) {
      const term = SOLAR_TERMS[i];
      const next = SOLAR_TERMS[(i + 1) % SOLAR_TERMS.length];
      let end = next.longitude === 0 ? 360 : next.longitude;
      let inRange =
        (term.longitude <= sunLon && sunLon < end) ||
        (term.longitude > end && (sunLon >= term.longitude || sunLon < end));
      if (inRange) {
        currentTerm = term;
        nextTerm = next;
        break;
      }
    }
    let degreesToNext = nextTerm
      ? (nextTerm.longitude - sunLon + 360) % 360
      : 0;
    return {
      currentTerm,
      nextTerm,
      sunLongitude: sunLon,
      degreesToNext,
      daysToNext: Math.round(degreesToNext),
      nextTermDate: new Date(date.getTime() + degreesToNext * 86400000),
    };
  } catch (e) {
    return {
      currentTerm: null,
      nextTerm: null,
      sunLongitude: 0,
      degreesToNext: 0,
      daysToNext: 0,
      nextTermDate: new Date(),
    };
  }
}

export function getSolarTermEvents(date, daysBefore = 7, daysAfter = 30) {
  const events = [];
  const endDate = new Date(date.getTime() + daysAfter * 86400000);
  let checkDate = new Date(date.getTime() - daysBefore * 86400000);
  let prevTermIndex = -1;
  while (checkDate <= endDate) {
    const sunLon = getPlanetLongitude("Sun", checkDate);
    for (let i = 0; i < SOLAR_TERMS.length; i++) {
      const term = SOLAR_TERMS[i];
      const next = SOLAR_TERMS[(i + 1) % SOLAR_TERMS.length];
      let end = next.longitude === 0 ? 360 : next.longitude;
      let inRange =
        (term.longitude <= sunLon && sunLon < end) ||
        (term.longitude > end && (sunLon >= term.longitude || sunLon < end));
      if (inRange && i !== prevTermIndex) {
        if (prevTermIndex !== -1)
          events.push({
            term: term,
            date: new Date(checkDate),
            isPast: checkDate < date,
          });
        prevTermIndex = i;
        break;
      }
    }
    checkDate = new Date(checkDate.getTime() + 86400000);
  }
  return events;
}

export function getEclipses(date, daysRange = 365) {
  const eclipses = [];
  try {
    const endDate = new Date(date.getTime() + daysRange * 86400000);
    let t = Astronomy.MakeTime(new Date(date.getTime() - 86400000));
    let se = Astronomy.SearchGlobalSolarEclipse(t);
    while (se && se.peak.date <= endDate) {
      let kind = String(se.kind).toLowerCase();
      let type = "日食",
        symbol = "🌑",
        j = "不明";
      if (kind.includes("total")) {
        type = "皆既日食";
        j = "皆既";
      } else if (kind.includes("annular")) {
        type = "金環日食";
        symbol = "💍";
        j = "金環";
      } else if (kind.includes("hybrid")) {
        type = "金環皆既日食";
        symbol = "🌓";
        j = "金環皆既";
      } else if (kind.includes("partial")) {
        type = "部分日食";
        symbol = "🌘";
        j = "部分";
      }
      eclipses.push({
        type,
        symbol,
        japaneseKind: j,
        kind: se.kind,
        date: se.peak.date,
        isPast: se.peak.date < date,
        category: "solar",
        obscuration: se.obscuration,
        magnitude: se.magnitude,
      });
      se = Astronomy.NextGlobalSolarEclipse(se.peak);
    }
    let le = Astronomy.SearchLunarEclipse(t);
    while (le && le.peak.date <= endDate) {
      let kind = String(le.kind).toLowerCase();
      let type = "月食",
        symbol = "🌕",
        j = "不明";
      if (kind.includes("total")) {
        type = "皆既月食";
        symbol = "🔴";
        j = "皆既";
      } else if (kind.includes("partial")) {
        type = "部分月食";
        symbol = "🌗";
        j = "部分";
      } else if (kind.includes("penumbral")) {
        type = "半影月食";
        symbol = "⚫";
        j = "半影";
      }
      eclipses.push({
        type,
        symbol,
        japaneseKind: j,
        kind: le.kind,
        date: le.peak.date,
        isPast: le.peak.date < date,
        category: "lunar",
        magnitude: le.magnitude,
      });
      le = Astronomy.NextLunarEclipse(le.peak);
    }
    eclipses.sort((a, b) => a.date - b.date);
  } catch (e) { }
  return eclipses;
}

/**
 * イングレス（サイン移動）取得 (サイデリアル対応の完全化)
 */
export function getIngresses(
  date,
  daysBefore = 3,
  daysAfter = 14,
  isHeliocentric = false,
  isSidereal = false,
  showExtendedPoints = false,
) {
  const ingresses = [];
  try {
    const startDate = new Date(date.getTime() - daysBefore * 86400000);
    const endDate = new Date(date.getTime() + daysAfter * 86400000);

    const getAyanamsha = function (d) {
      const jd = d.getTime() / 86400000 + 2440587.5;
      return 23.8528 + ((50.29 / 3600) * (jd - 2451545.0)) / 365.25;
    };

    const getSignWithSidereal = function (lon, d) {
      if (lon === null || lon === undefined) return null;
      if (isSidereal) {
        const ayan = calculateLahiriAyanamsha(d); // 統一計算関数を使用
        return getZodiacSign((lon - ayan + 360) % 360);
      }
      return getZodiacSign(lon);
    };

    let planetList = Object.keys(PLANET_BODIES);
    if (isHeliocentric) {
      planetList = planetList.filter((p) => p !== "Sun" && p !== "Moon");
    }

    planetList.forEach((planet) => {
      let prevSign = null;
      let check = new Date(startDate);
      while (check <= endDate) {
        // getAnyPlanetLongitude を使用して小惑星にも対応
        const lon = getAnyPlanetLongitude(planet, check, isHeliocentric);
        const sign = getSignWithSidereal(lon, check);

        // 前後のサインを比較（両方が取得できている場合のみ）
        if (sign && prevSign && prevSign.name !== sign.name) {
          let low = check.getTime() - 3600000;
          let high = check.getTime();

          // 精密な時刻特定 (10回反復で約3秒精度)
          for (let i = 0; i < 10; i++) {
            let mid = (low + high) / 2;
            const midDate = new Date(mid);
            const midLon = getAnyPlanetLongitude(
              planet,
              midDate,
              isHeliocentric,
            );
            const midSign = getSignWithSidereal(midLon, midDate);

            // 安全なプロパティアクセスに修正
            if (midSign && midSign.name === sign.name) {
              high = mid;
            } else {
              low = mid;
            }
          }
          const exactTime = new Date(high);
          const exactLon = getAnyPlanetLongitude(
            planet,
            exactTime,
            isHeliocentric,
          );
          const finalSign = getSignWithSidereal(exactLon, exactTime);
          const dignity = getDignity(planet, finalSign.name);
          ingresses.push({
            planet,
            date: exactTime,
            fromSign: prevSign,
            toSign: finalSign,
            longitude: isSidereal
              ? (exactLon - getAyanamsha(exactTime) + 360) % 360
              : exactLon,
            isPast: exactTime < date,
            dignity,
          });
        }
        prevSign = sign;
        check = new Date(check.getTime() + 3600000); // 1時間ステップ
      }
    });
    ingresses.sort((a, b) => a.date - b.date);
  } catch (e) {
    console.error("getIngresses precision error:", e);
  }
  return ingresses;
}

/**
 * 修正版：チャートタイムラインに基づくイングレス取得
 * 1. チャートの全期間（timeline）を走査し、正確なインデックスを付与します。
 * 2. 外惑星の数年に一度の移動も、タイムラインに含まれていれば確実に捕捉します。
 */
export function getIngressesForTimeline(
  timeline,
  isHeliocentric = false,
  isSidereal = false,
) {
  const ingresses = [];
  if (!timeline || timeline.length < 2) return ingresses;

  try {
    // 計算に使用するアヤナンシャ取得関数
    const getSignWithSidereal = function (lon, d) {
      if (lon === null || lon === undefined) return null;
      if (isSidereal) {
        const ayan = calculateLahiriAyanamsha(d);
        return getZodiacSign((lon - ayan + 360) % 360);
      }
      return getZodiacSign(lon);
    };

    // 対象惑星リストの選定
    let planetList = Object.keys(PLANET_BODIES);
    if (isHeliocentric) {
      planetList = planetList.filter((p) => p !== "Sun" && p !== "Moon");
    } else {
      // ジオセントリック時は「地球(Earth)」を計算から除外
      planetList = planetList.filter((p) => p !== "Earth");
    }

    planetList.forEach((planet) => {
      let prevSign = null;

      // タイムライン（ローソク足）を一つずつ走査
      for (let i = 0; i < timeline.length; i++) {
        const row = timeline[i];
        const date = new Date(row.timestamp);

        // 経度とサインを取得
        const lon = getAnyPlanetLongitude(planet, date, isHeliocentric);
        const sign = getSignWithSidereal(lon, date);

        if (sign && prevSign && prevSign.name !== sign.name) {
          // サイン移動を検出：結果を保存
          ingresses.push({
            index: i, // チャート描画に必須のインデックス
            planet,
            date: date,
            fromSign: prevSign,
            toSign: sign,
            longitude: lon,
            dignity: getDignity(planet, sign.name),
            isFuture: row.isFuture || false,
          });
        }
        prevSign = sign;
      }
    });

    // 日付順にソート
    ingresses.sort((a, b) => a.date - b.date);
  } catch (e) {
    console.error("getIngressesForTimeline error:", e);
  }
  return ingresses;
}

export function getMercuryRetroStatus(date) {
  try {
    const isRx = isRetrograde("Mercury", date);
    let status = isRx ? "Retrograde" : "Direct";
    let phase = isRx ? "         " : null;
    let rxStart = null,
      rxEnd = null;
    return { isRetrograde: isRx, status, phase, rxStart, rxEnd };
  } catch (e) {
    return {
      isRetrograde: false,
      status: "Direct",
      phase: null,
      rxStart: null,
      rxEnd: null,
    };
  }
}

/**
 * 年間の全惑星逆行データを一括計算
 */
/**
 * 年間の全惑星逆行データを一括計算
 */
export function getYearlyRetrogrades(year) {
  const planets = [
    "Mercury",
    "Venus",
    "Mars",
    "Jupiter",
    "Saturn",
    "Uranus",
    "Neptune",
    "Pluto",
  ];
  const results = {};
  const startDate = new Date(year, 0, 1);
  const endDate = new Date(year, 11, 31);

  planets.forEach((p) => {
    results[p] = [];
    let current = new Date(startDate);
    let inRetro = false;
    let retroStart = null;

    while (current <= endDate) {
      const speed = getPlanetSpeed(p, current);
      if (speed && speed.isRetrograde && !inRetro) {
        inRetro = true;
        retroStart = new Date(current);
      } else if (speed && !speed.isRetrograde && inRetro) {
        inRetro = false;
        results[p].push({
          start: retroStart,
          end: new Date(current),
          durationDays: Math.round((current - retroStart) / 86400000),
        });
      }
      current.setDate(current.getDate() + 1);
    }
    if (inRetro) {
      results[p].push({
        start: retroStart,
        end: endDate,
        durationDays: Math.round((endDate - retroStart) / 86400000),
      });
    }
  });
  return results;
}

/**
 * 惑星が特定の黄経を通過する時刻を特定する（順行前提）
 */
function findCrossingTime(planet, targetLon, tStart, tEnd, forward = true) {
  let low = tStart.getTime();
  let high = tEnd.getTime();
  const maxIter = 15;

  for (let i = 0; i < maxIter; i++) {
    const mid = (low + high) / 2;
    const midLon = getPlanetLongitude(planet, new Date(mid));
    if (midLon === null) break;

    let diff = midLon - targetLon;
    while (diff <= -180) diff += 360;
    while (diff > 180) diff -= 360;

    // 前方に進んでいる際にターゲットを越えたかどうか
    if (forward) {
      if (diff > 0) high = mid;
      else low = mid;
    } else {
      if (diff > 0) low = mid;
      else high = mid;
    }
  }
  return new Date((low + high) / 2);
}

/**
 * 逆行の精密な詳細データ（度数ベースのシャドウ期間含む）を計算
 */
export function getRetrogradeDetails(year, planet) {
  const rawRx = getYearlyRetrogrades(year)[planet] || [];
  
  // 各惑星の標準的なシャドウ探索範囲（日）
  const searchOffsets = {
    Mercury: 30,
    Venus: 60,
    Mars: 90,
    Jupiter: 120,
    Saturn: 120,
    Uranus: 150,
    Neptune: 150,
    Pluto: 180
  };
  const offset = searchOffsets[planet] || 45;

  return rawRx.map(rx => {
    if (!rx || !rx.start || !rx.end) return null;

    // 1. ステーション時刻の精密化 (速度が 0 になる瞬間)
    // 簡易的に現状の start/end を使用するが、度数はその時刻で取得
    const startLon = getPlanetLongitude(planet, rx.start);
    const endLon = getPlanetLongitude(planet, rx.end);

    // 2. プレ・シャドウ (逆行開始前、最後に Direct で endLon を通過した時点)
    const preShadowStart = findCrossingTime(
      planet,
      endLon,
      new Date(rx.start.getTime() - offset * 86400000),
      rx.start,
      true
    );

    // 3. ポスト・シャドウ (逆行終了後、最初に Direct で startLon を通過した時点)
    const postShadowEnd = findCrossingTime(
      planet,
      startLon,
      rx.end,
      new Date(rx.end.getTime() + offset * 86400000),
      true
    );

    return {
      ...rx,
      planet,
      startLon,
      endLon,
      startSign: getZodiacSign(startLon),
      endSign: getZodiacSign(endLon),
      preShadow: {
        start: preShadowStart,
        end: rx.start,
      },
      postShadow: {
        start: rx.end,
        end: postShadowEnd,
      },
    };
  }).filter(item => item !== null);
}

/**
 * 全惑星の逆行詳細を一括計算
 */
export function getAllPlanetsRetroDetails(year) {
  const planets = [
    "Mercury", "Venus", "Mars", "Jupiter", "Saturn", "Uranus", "Neptune", "Pluto"
  ];
  let allDetails = [];
  planets.forEach(p => {
    const details = getRetrogradeDetails(year, p);
    allDetails = allDetails.concat(details);
  });
  // 日付順にソート
  return allDetails.sort((a, b) => a.start - b.start);
}

// 互換性のためのエイリアス
export const getMercuryRetroDetails = (year) => getRetrogradeDetails(year, "Mercury");

export function getDeclination(planet, date) {
  try {
    const body = PLANET_BODIES[planet];
    if (!body) return null;
    const time = Astronomy.MakeTime(date);
    const geo = Astronomy.GeoVector(body, time, false);
    const r = Math.sqrt(geo.x * geo.x + geo.y * geo.y + geo.z * geo.z);
    return Math.asin(geo.z / r) * (180 / Math.PI);
  } catch (e) {
    return null;
  }
}

export const getPlanetDeclination = getDeclination;

/**
 * アウト・オブ・バウンズ (OOB) 天体の取得
 * ヘリオセントリック時は「赤緯 23.44度」の代わりに「日心黄緯 23.44度」で判定します。
 */
export function getOOBPlanets(date, isHeliocentric = false) {
  const oob = [];
  try {
    const bodies = isHeliocentric
      ? [
        "Mercury",
        "Venus",
        "Earth",
        "Mars",
        "Jupiter",
        "Saturn",
        "Uranus",
        "Neptune",
        "Pluto",
      ]
      : Object.keys(PLANET_BODIES);

    bodies.forEach((p) => {
      if (!isHeliocentric && p === "Sun") return;

      const val = isHeliocentric
        ? getHeliocentricLatitude(p, date)
        : getDeclination(p, date);

      if (Math.abs(val) > 23.44)
        oob.push({
          planet: p,
          [isHeliocentric ? "latitude" : "declination"]: val,
          direction: val > 0 ? "North" : "South",
          excess: Math.abs(val) - 23.44,
        });
    });
  } catch (e) {
    console.error("getOOBPlanets error:", e);
  }
  return oob;
}

export function getDeclinationAspect(p1, p2, date, orb = 1.0) {
  const d1 = getDeclination(p1, date);
  const d2 = getDeclination(p2, date);
  if (d1 === null || d2 === null) return null;
  if (Math.abs(d1 - d2) <= orb)
    return {
      type: "parallel",
      planet1: p1,
      planet2: p2,
      dec1: d1,
      dec2: d2,
      orb: Math.abs(d1 - d2),
      description: `${p1} || ${p2}`,
    };
  if (Math.abs(d1 + d2) <= orb)
    return {
      type: "contra-parallel",
      planet1: p1,
      planet2: p2,
      dec1: d1,
      dec2: d2,
      orb: Math.abs(d1 + d2),
      description: `${p1} ⊥ ${p2}`,
    };
  return null;
}

/**
 * 赤緯アスペクト（パラレル・コントラパラレル）の計算
 * 指摘に基づき、単位不一致の解消と符号判定ロジックを完全実装
 */
export function getAllDeclinationAspects(date, options = {}) {
  const planets = [
    "Sun",
    "Moon",
    "Mercury",
    "Venus",
    "Mars",
    "Jupiter",
    "Saturn",
    "Uranus",
    "Neptune",
    "Pluto",
  ];

  // 1. フィルタリング：月の除外設定
  let targetBodies = options.includeMoon
    ? planets
    : planets.filter((p) => p !== "Moon");

  // 2. フィルタリング：重要天体（火星以遠）のみ
  if (options.majorOnly) {
    const major = ["Mars", "Jupiter", "Saturn", "Uranus", "Neptune", "Pluto"];
    targetBodies = targetBodies.filter((p) => major.includes(p));
  }

  // 各天体の赤緯を取得
  const bodyData = targetBodies
    .map((name) => {
      // 既存の getDeclination 関数を使用して度（Degrees）で取得
      const dec = getDeclination(name, date);
      return { name, dec };
    })
    .filter((d) => d.dec !== null);

  const results = [];
  // オーブの設定（指摘に基づきデフォルト値を調整）
  const maxOrb = options.useStrictOrb
    ? options.strictOrb || 0.2
    : options.orb || 1.0;

  // 3. 総当たりでアスペクトを判定
  for (let i = 0; i < bodyData.length; i++) {
    for (let j = i + 1; j < bodyData.length; j++) {
      const b1 = bodyData[i];
      const b2 = bodyData[j];

      const dec1 = b1.dec;
      const dec2 = b2.dec;

      /**
       * パラレル (Parallel) の判定
       * 同符号（N/N または S/S）かつ、絶対値の差がオーブ以内
       */
      const sameHemisphere = dec1 * dec2 >= 0;
      const pOrb = Math.abs(dec1 - dec2);

      if (sameHemisphere && pOrb <= maxOrb) {
        results.push({
          planet1: b1.name,
          planet2: b2.name,
          dec1: dec1,
          dec2: dec2,
          orb: pOrb,
          type: "parallel",
          symbol: "∥",
        });
        continue; // 同一ペアで重複判定を避ける
      }

      /**
       * コントラパラレル (Contra-Parallel) の判定
       * 逆符号（N/S）かつ、絶対値の差がオーブ以内
       */
      const oppositeHemisphere = dec1 * dec2 < 0;
      const cpOrb = Math.abs(Math.abs(dec1) - Math.abs(dec2));

      if (oppositeHemisphere && cpOrb <= maxOrb) {
        results.push({
          planet1: b1.name,
          planet2: b2.name,
          dec1: dec1,
          dec2: dec2,
          orb: cpOrb,
          type: "contra-parallel",
          symbol: "⊥",
        });
      }
    }
  }

  // オーブの狭い順にソートして返却
  return results.sort((a, b) => a.orb - b.orb);
}

/**
 * 日心黄緯アスペクト（パラレル・コントラパラレル）の計算
 */
export function getAllHeliocentricLatitudeAspects(date, options = {}) {
  const planets = [
    "Mercury",
    "Venus",
    "Earth",
    "Mars",
    "Jupiter",
    "Saturn",
    "Uranus",
    "Neptune",
    "Pluto",
  ];

  let targetBodies = planets;

  if (options.majorOnly) {
    const major = ["Mars", "Jupiter", "Saturn", "Uranus", "Neptune", "Pluto"];
    targetBodies = targetBodies.filter((p) => major.includes(p));
  }

  const bodyData = targetBodies
    .map((name) => {
      const dec = getHeliocentricLatitude(name, date);
      return { name, dec };
    })
    .filter((d) => d.dec !== null);

  const results = [];
  const maxOrb = options.useStrictOrb
    ? options.strictOrb || 0.2
    : options.orb || 1.0;

  for (let i = 0; i < bodyData.length; i++) {
    for (let j = i + 1; j < bodyData.length; j++) {
      const b1 = bodyData[i];
      const b2 = bodyData[j];
      const dec1 = b1.dec;
      const dec2 = b2.dec;

      const sameHemisphere = dec1 * dec2 >= 0;
      const pOrb = Math.abs(dec1 - dec2);

      if (sameHemisphere && pOrb <= maxOrb) {
        results.push({
          planet1: b1.name,
          planet2: b2.name,
          dec1: dec1,
          dec2: dec2,
          orb: pOrb,
          type: "parallel",
          symbol: "∥",
        });
        continue;
      }

      const oppositeHemisphere = dec1 * dec2 < 0;
      const cpOrb = Math.abs(Math.abs(dec1) - Math.abs(dec2));

      if (oppositeHemisphere && cpOrb <= maxOrb) {
        results.push({
          planet1: b1.name,
          planet2: b2.name,
          dec1: dec1,
          dec2: dec2,
          orb: cpOrb,
          type: "contra-parallel",
          symbol: "⊥",
        });
      }
    }
  }

  return results.sort((a, b) => a.orb - b.orb);
}

export function checkCriticalDegree(longitude, orb = 1) {
  const signIndex = Math.floor(longitude / 30);
  const deg = longitude % 30;
  const modality = ["Cardinal", "Fixed", "Mutable"][signIndex % 3];
  const crits = {
    Cardinal: [0, 13, 26],
    Fixed: [8.367, 21.717],
    Mutable: [4, 17],
  };
  const results = [];
  (crits[modality] || []).forEach((c) => {
    if (Math.abs(deg - c) <= orb)
      results.push({
        type: modality,
        degree: c,
        orb: Math.abs(deg - c),
        description: `${modality} Critical`,
      });
  });
  if (Math.abs(deg - 29) <= orb)
    results.push({
      type: "Anaretic",
      degree: 29,
      orb: Math.abs(deg - 29),
      description: "Anaretic",
    });
  if (Math.abs(deg - 15) <= orb)
    results.push({
      type: "Avatar",
      degree: 15,
      orb: Math.abs(deg - 15),
      description: "Avatar",
    });
  if (deg <= orb)
    results.push({
      type: "Ingress",
      degree: 0,
      orb: deg,
      description: "Ingress",
    });
  return results;
}

export function getAllCriticalDegrees(positions, orb = 1.5) {
  const alerts = [];
  Object.keys(positions).forEach((p) => {
    if (!PLANET_BODIES[p]) return;
    const crits = checkCriticalDegree(positions[p], orb);
    if (crits.length)
      alerts.push({
        planet: p,
        longitude: positions[p],
        sign: getZodiacSign(positions[p]),
        degreeInSign: positions[p] % 30,
        criticals: crits,
      });
  });
  return alerts;
}

/**
 * ギャン Square of Nine 計算ロジックの実装
 * 価格 P の転換点 = (√P ± 角度/180)^2
 */
export function gannSquareOfNine(price) {
  if (!price || price <= 0) return {};
  const root = Math.sqrt(price);
  return {
    sqrt: root,
    majorLevels: {
      // 90度 = 0.5(平方根空間), 180度 = 1.0(平方根空間)
      resistance1: Math.pow(root + 0.5, 2), // +90°
      resistance2: Math.pow(root + 1.0, 2), // +180°
      support1: Math.pow(Math.max(0, root - 0.5), 2), // -90°
      support2: Math.pow(Math.max(0, root - 1.0), 2), // -180°
    },
  };
}

export function getGannLevels(price, count = 8) {
  if (!price || price <= 0) return { resistances: [], supports: [] };
  const root = Math.sqrt(price);
  const resistances = [];
  const supports = [];

  // 45度刻みでレベルを算出
  for (let i = 1; i <= count; i++) {
    const angle = i * 45;
    const factor = angle / 180;

    const rPrice = Math.pow(root + factor, 2);
    const sPrice = Math.pow(Math.max(0, root - factor), 2);

    resistances.push({
      angle,
      price: rPrice,
      change: (rPrice / price - 1) * 100,
    });
    supports.push({
      angle,
      price: sPrice,
      change: (sPrice / price - 1) * 100,
    });
  }
  return { resistances, supports };
}

export function getSunTimes(date, latitude = 35.6762, longitude = 139.6503) {
  try {
    const obs = new Astronomy.Observer(latitude, longitude, 0);
    const rise = Astronomy.SearchRiseSet("Sun", obs, +1, date, 1);
    const set = Astronomy.SearchRiseSet("Sun", obs, -1, date, 1);
    const nextRise = Astronomy.SearchRiseSet(
      "Sun",
      obs,
      +1,
      new Date(date.getTime() + 86400000),
      1,
    );
    const prevSet = Astronomy.SearchRiseSet(
      "Sun",
      obs,
      -1,
      new Date(date.getTime() - 86400000),
      1,
    );
    return {
      sunrise: rise ? rise.date : null,
      sunset: set ? set.date : null,
      nextSunrise: nextRise ? nextRise.date : null,
      prevSunset: prevSet ? prevSet.date : null,
    };
  } catch (e) {
    return {};
  }
}

// ========================================
// 惑星時間の計算ロジック (astronomy.js に追記・置換)
// ========================================

// カルデア配列（惑星の順序：土星→木星→火星→太陽→金星→水星→月）
const CHALDEAN_ORDER = [
  "Saturn",
  "Jupiter",
  "Mars",
  "Sun",
  "Venus",
  "Mercury",
  "Moon",
];

// 曜日の支配星（日曜=0 から開始）
const DAY_RULERS = [
  "Sun",
  "Moon",
  "Mars",
  "Mercury",
  "Jupiter",
  "Venus",
  "Saturn",
];

export function getPlanetaryHourMeaning(planet) {
  const meanings = {
    Sun: {
      keywords: ["成功", "活力", "権威", "創造"],
      activities: "公的な活動、昇進の願い、重要人物との面会、創造的な活動",
      avoid: "隠し事、謙虚さが求められる場面",
    },
    Moon: {
      keywords: ["変化", "感情", "家庭", "大衆"],
      activities: "旅行、引越し、料理、掃除、一般大衆向けの宣伝、休養",
      avoid: "永続性が必要なこと、重要な決断（気分が変わりやすいため）",
    },
    Mercury: {
      keywords: ["通信", "知性", "商売", "移動"],
      activities: "勉強、執筆、契約、メール送信、短距離の移動、商談",
      avoid: "結婚の約束、長期的な不動産契約（気が変わりやすいため）",
    },
    Venus: {
      keywords: ["愛", "美", "金銭", "調和"],
      activities: "デート、芸術鑑賞、美容、パーティー、金銭的な投資、和解",
      avoid: "汚れる作業、激しい争い、外科手術",
    },
    Mars: {
      keywords: ["行動", "勇気", "闘争", "機械"],
      activities: "スポーツ、競争、機械の修理、勇気のいる決断、外科手術",
      avoid: "平和的な交渉、静かな休息、喧嘩の仲裁",
    },
    Jupiter: {
      keywords: ["幸運", "拡大", "富", "宗教"],
      activities: "法律相談、投資、学習、慈善活動、有力者への支援要請",
      avoid: "詳細な分析が必要な作業（大雑把になりやすいため）",
    },
    Saturn: {
      keywords: ["制限", "忍耐", "土地", "組織"],
      activities: "長期計画の策定、農業、不動産取引、整理整頓、孤独な作業",
      avoid: "新しいことの開始、社交的な集まり、借金",
    },
  };
  return meanings[planet] || { keywords: [], activities: "", avoid: "" };
}

/**
 * 惑星、感受点（ノード・アングル）の経度を統合取得（ジオ/ヘリオ対応）
 * 修正内容：
 * 1. 小惑星のロジックを完全に削除しました。
 * 2. 感受点（NorthNode, ASC, MC等）は「小惑星」ではないため、引き続き取得対象として維持します。
 */
export function getAnyPlanetLongitude(planet, date, isHelio = false, latitude = null, longitude = null) {
  if (isHelio === true) {
    return getHeliocentricLongitude(planet, date);
  }

  // 1. 通常の主要惑星（Sun, Moon, Mercury - Pluto）を取得
  const standard = getPlanetLongitude(planet, date);
  if (standard !== null) return standard;

  // 2. 感受点（NorthNode, ASC, MC 等）の位置を取得
  try {
    const extended = getExtendedPoints(date, latitude, longitude);
    if (extended[planet] !== undefined) {
      return extended[planet];
    }
  } catch (e) {
    return null;
  }

  return null;
}


/**
 * アスペクトが正確（Exact）になる時刻を精密に特定するためのヘルパー
 */
function findExactAspectTime(p1, p2, targetAngle, tStart, tEnd, isHelio) {
  let low = tStart.getTime();
  let high = tEnd.getTime();

  // 15回の反復（二分探索的な絞り込み）で分単位の精度を確保
  for (let i = 0; i < 15; i++) {
    const m1 = low + (high - low) * 0.382;
    const m2 = low + (high - low) * 0.618;

    const getOrb = (timeMs) => {
      const d = new Date(timeMs);
      const lon1 = isHelio ? getHeliocentricLongitude(p1, d) : getAnyPlanetLongitude(p1, d);
      const lon2 = isHelio ? getHeliocentricLongitude(p2, d) : getAnyPlanetLongitude(p2, d);
      if (lon1 === null || lon2 === null) return 999;
      let diff = Math.abs(lon1 - lon2);
      if (diff > 180) diff = 360 - diff;
      return Math.abs(diff - targetAngle);
    };

    if (getOrb(m1) < getOrb(m2)) {
      high = m2;
    } else {
      low = m1;
    }
  }
  return new Date((low + high) / 2);
}


/**
 * 拡張版アスペクト検索
 * 修正内容：小惑星（Asteroids）リストを完全に削除しました。
 */
export function searchAspectsExtended(options) {
  const planet1 = options.planet1;
  const planet2 = options.planet2;
  const aspectType = options.aspectType;
  const fromDate = options.fromDate;
  const toDate = options.toDate;
  const signFilter = options.signFilter;
  const rxFilter = options.rxFilter;
  const isHeliocentric = options.isHeliocentric;
  const isSidereal = options.isSidereal;
  const maxResults = options.maxResults || 40000;

  const results = [];
  let aspectList = [];

  if (aspectType === "all") {
    aspectList = [...ASPECTS.major, ...ASPECTS.minor];
  } else if (ASPECTS[aspectType]) {
    aspectList = ASPECTS[aspectType];
  } else {
    const all = [...ASPECTS.major, ...ASPECTS.minor];
    const found = all.find(function (a) {
      return a.name === aspectType;
    });
    if (found) aspectList = [found];
  }

  if (aspectList.length === 0) return [];

  // 天体リスト（主要惑星 + 感受点のみ）
  let planets = [];
  if (isHeliocentric === true) {
    planets = [
      "Earth",
      "Mercury",
      "Venus",
      "Mars",
      "Jupiter",
      "Saturn",
      "Uranus",
      "Neptune",
      "Pluto",
    ];
  } else {
    planets = [
      "Sun",
      "Moon",
      "Mercury",
      "Venus",
      "Mars",
      "Jupiter",
      "Saturn",
      "Uranus",
      "Neptune",
      "Pluto",
      "NorthNode",
      "SouthNode",
    ];
  }

  const pairs = [];
  for (let i = 0; i < planets.length; i++) {
    for (let j = i + 1; j < planets.length; j++) {
      const p1 = planets[i],
        p2 = planets[j];
      const isAny1 = !planet1 || planet1 === "Any";
      const isAny2 = !planet2 || planet2 === "Any";
      if (
        (isAny1 || planet1 === p1 || planet1 === p2) &&
        (isAny2 || planet2 === p1 || planet2 === p2)
      ) {
        pairs.push([p1, p2]);
      }
    }
  }

  const startTs = fromDate.getTime();
  const totalDays = Math.ceil((toDate.getTime() - startTs) / 86400000);
  const step =
    planet1 === "Moon" || planet2 === "Moon" || !planet1 || planet1 === "Any"
      ? 0.25
      : 1;

  for (let d = 0; d <= totalDays && results.length < maxResults; d += step) {
    const curDate = new Date(startTs + d * 86400000);
    for (let k = 0; k < pairs.length; k++) {
      const p1 = pairs[k][0],
        p2 = pairs[k][1];
      const lon1 = isHeliocentric
        ? getHeliocentricLongitude(p1, curDate)
        : getAnyPlanetLongitude(p1, curDate);
      const lon2 = isHeliocentric
        ? getHeliocentricLongitude(p2, curDate)
        : getAnyPlanetLongitude(p2, curDate);

      if (lon1 === null || lon2 === null) continue;

      let diff = Math.abs(lon1 - lon2);
      if (diff > 180) diff = 360 - diff;

      for (let m = 0; m < aspectList.length; m++) {
        const aspect = aspectList[m];
        const orb = Math.abs(diff - aspect.angle);
        if (orb <= 1.0) {
          const rx1 = isRetrograde(p1, curDate, isHeliocentric);
          const rx2 = isRetrograde(p2, curDate, isHeliocentric);
          const sign1 = getZodiacSign(lon1);
          const sign2 = getZodiacSign(lon2);

          if (
            signFilter &&
            sign1.name !== signFilter &&
            sign2.name !== signFilter
          )
            continue;
          if (rxFilter === "Yes" && !rx1 && !rx2) continue;
          if (rxFilter === "No" && (rx1 || rx2)) continue;

          const isDup = results.some(function (r) {
            return (
              r.planet1 === p1 &&
              r.planet2 === p2 &&
              r.aspect.name === aspect.name &&
              Math.abs(r.date.getTime() - curDate.getTime()) < 3 * 86400000
            );
          });

          if (!isDup) {
            // --- 追加：正確な成立時刻を特定する ---
            const exactDate = findExactAspectTime(
              p1, p2, aspect.angle,
              new Date(curDate.getTime() - step * 86400000),
              new Date(curDate.getTime() + step * 86400000),
              isHeliocentric
            );

            // 精密時刻における座標とオーブを再取得
            const lon1_ex = isHeliocentric ? getHeliocentricLongitude(p1, exactDate) : getAnyPlanetLongitude(p1, exactDate);
            const lon2_ex = isHeliocentric ? getHeliocentricLongitude(p2, exactDate) : getAnyPlanetLongitude(p2, exactDate);
            let diff_ex = Math.abs(lon1_ex - lon2_ex);
            if (diff_ex > 180) diff_ex = 360 - diff_ex;

            results.push({
              date: exactDate, // 精密化された Date オブジェクト
              planet1: p1,
              planet2: p2,
              aspect: aspect,
              orb: Math.abs(diff_ex - aspect.angle),
              // ★isSidereal と時刻を渡すように修正
              sign1: getZodiacSign(lon1_ex, isSidereal, exactDate),
              sign2: getZodiacSign(lon2_ex, isSidereal, exactDate),
              rx1: isRetrograde(p1, exactDate, isHeliocentric),
              rx2: isRetrograde(p2, exactDate, isHeliocentric),
              lon1: lon1_ex,
              lon2: lon2_ex,
            });
          }
        }
      }
    }
  }
  return results;
}

/**
 * セカンダリー・プログレッション（1日1年法）による主要ポイントの計算
 */
export function getSecondaryProgressionPositions(natalDate, targetDate, latitude, longitude) {
  try {
    const nDate = natalDate instanceof Date ? natalDate : new Date(natalDate);
    const tDate = targetDate instanceof Date ? targetDate : new Date(targetDate);

    if (isNaN(nDate.getTime()) || isNaN(tDate.getTime())) return {};

    const diffMs = tDate.getTime() - nDate.getTime();
    if (diffMs < 0) return {};

    // 1年 = 1日 (セカンダリー・プログレッション)
    // 365.242199 日 = 1回帰年
    const years = diffMs / (365.242199 * 24 * 3600 * 1000);
    const progressedDate = new Date(nDate.getTime() + years * 24 * 3600 * 1000);

    const positions = {
      Moon: getPlanetLongitude("Moon", progressedDate),
    };

    if (latitude !== null && longitude !== null) {
      const angles = getAscendantMC(progressedDate, latitude, longitude);
      positions.ASC = angles.ascendant;
      positions.MC = angles.mc;
    }

    return positions;
  } catch (e) {
    console.error("getSecondaryProgressionPositions error:", e);
    return {};
  }
}

/**
 * ハードアスペクト（45度の倍数）の判定
 */
export function isHardAspect(lon1, lon2, orb = 1.0) {
  if (lon1 === null || lon2 === null) return false;
  let diff = Math.abs(lon1 - lon2) % 45;
  if (diff > 22.5) diff = 45 - diff;
  return diff < orb;
}
